/*
<auto-generated>
This code was generated from DaBNet.Kamu.Services.DB.CodeGenUI at 26.02.2024
</auto-generated>
*/


export class GenBankaVpos {
    GenBanka:GenBanka;
    AcikKapali:string;
    AcikKapali3D?:string;
    Akis?:string;
    BankaKodu:string;
    BankaSube?:string;
    BankaTuru?:string;
    BelediyeKod:number;
    CariHesap?:string;
    DefaultBanka?:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    Isim:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod?:number;
    MerchantId?:string;
    MusteriNo:string;
    Sifre:string;
    SqBankaVposId?:number;
    Tid?:string;
    WsDogrulamaCustemail?:string;
    WsDogrulamaSifre?:string;
    WsDogrulamaTermerchid?:string;
    WsDogrulamaTermprovid?:string;
    WsDogrulamaTermuserid?:string;
    WsUrl?:string;
    WsUrl3D?:string;
    WsUrlDogrulama?:string;

    constructor(item?:any){
    this.GenBanka=item?.GenBanka;
    this.AcikKapali=item?.AcikKapali||'';
    this.AcikKapali3D=item?.AcikKapali3D;
    this.Akis=item?.Akis;
    this.BankaKodu=item?.BankaKodu||'';
    this.BankaSube=item?.BankaSube;
    this.BankaTuru=item?.BankaTuru;
    this.BelediyeKod=item?.BelediyeKod||0;
    this.CariHesap=item?.CariHesap;
    this.DefaultBanka=item?.DefaultBanka;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.Isim=item?.Isim||'';
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod;
    this.MerchantId=item?.MerchantId;
    this.MusteriNo=item?.MusteriNo||'';
    this.Sifre=item?.Sifre||'';
    this.SqBankaVposId=item?.SqBankaVposId;
    this.Tid=item?.Tid;
    this.WsDogrulamaCustemail=item?.WsDogrulamaCustemail;
    this.WsDogrulamaSifre=item?.WsDogrulamaSifre;
    this.WsDogrulamaTermerchid=item?.WsDogrulamaTermerchid;
    this.WsDogrulamaTermprovid=item?.WsDogrulamaTermprovid;
    this.WsDogrulamaTermuserid=item?.WsDogrulamaTermuserid;
    this.WsUrl=item?.WsUrl;
    this.WsUrl3D=item?.WsUrl3D;
    this.WsUrlDogrulama=item?.WsUrlDogrulama;
    }
    }

    export class GenBelgeTuru {
    GenDosyaPlan:GenDosyaPlan;
    Ad:string;
    AktifEh:string;
    BelediyeKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    DosyaPlanKod?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    UstKod?:number;
    GenBelediye:GenBelediye;
    UstGenBelgeTuru?:GenBelgeTuru;
    GenBelgeTurus:GenBelgeTuru[];

    constructor(item?:any){
    this.GenDosyaPlan=item?.GenDosyaPlan;
    this.Ad=item?.Ad||'';
    this.AktifEh=item?.AktifEh||'';
    this.BelediyeKod=item?.BelediyeKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.DosyaPlanKod=item?.DosyaPlanKod;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.UstKod=item?.UstKod;
    this.GenBelediye=item?.GenBelediye;
    this.UstGenBelgeTuru=item?.UstGenBelgeTuru;
    this.GenBelgeTurus=item?.GenBelgeTurus;
    }
    }

    export class GenDosyaPlanBirim {
    GenDosyaPlan:GenDosyaPlan;
    BelediyeKod:number;
    BelgeIcerik?:string;
    BirimKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    DosyaPlanKod:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    GenBirim:GenBirim;

    constructor(item?:any){
    this.GenDosyaPlan=item?.GenDosyaPlan;
    this.BelediyeKod=item?.BelediyeKod||0;
    this.BelgeIcerik=item?.BelgeIcerik;
    this.BirimKod=item?.BirimKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.DosyaPlanKod=item?.DosyaPlanKod||'';
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.GenBirim=item?.GenBirim;
    }
    }

    export class GenKartBankaBin {
    GenBanka:GenBanka;
    AnlasmaDetayKod?:string;
    AnlasmaKod?:string;
    BankaKod?:string;
    BelediyeKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KartBanka?:string;
    KartNo:string;
    KartTipAd?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    Taksit?:string;

    constructor(item?:any){
    this.GenBanka=item?.GenBanka;
    this.AnlasmaDetayKod=item?.AnlasmaDetayKod;
    this.AnlasmaKod=item?.AnlasmaKod;
    this.BankaKod=item?.BankaKod;
    this.BelediyeKod=item?.BelediyeKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KartBanka=item?.KartBanka;
    this.KartNo=item?.KartNo||'';
    this.KartTipAd=item?.KartTipAd;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.Taksit=item?.Taksit;
    }
    }

    export class GenKullaniciRolYetki {
    GenFormDetay:GenFormDetay;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    FormKod:number;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KullaniciKod:number;
    MenuAnaKod:number;
    RolKod?:number;
    YetkiAd:string;
    YetkiTur:string;
    GenRol?:GenRol;

    constructor(item?:any){
    this.GenFormDetay=item?.GenFormDetay;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.FormKod=item?.FormKod||0;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KullaniciKod=item?.KullaniciKod||0;
    this.MenuAnaKod=item?.MenuAnaKod||0;
    this.RolKod=item?.RolKod;
    this.YetkiAd=item?.YetkiAd||'';
    this.YetkiTur=item?.YetkiTur||'';
    this.GenRol=item?.GenRol;
    }
    }

    export class GenOrganizasyon {
    GenOrganizasyonRol:GenOrganizasyonRol;
    AktifEh:string;
    BelediyeKod:number;
    BirimKod?:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KadroAdet?:number;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    RolAciklama:string;
    RolAd:string;
    UstKod?:number;
    GenBelediye:GenBelediye;
    GenBirim?:GenBirim;
    UstGenOrganizasyon?:GenOrganizasyon;
    GenOrganizasyons:GenOrganizasyon[];

    constructor(item?:any){
    this.GenOrganizasyonRol=item?.GenOrganizasyonRol;
    this.AktifEh=item?.AktifEh;
    this.BelediyeKod=item?.BelediyeKod||0;
    this.BirimKod=item?.BirimKod;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KadroAdet=item?.KadroAdet;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.RolAciklama=item?.RolAciklama;
    this.RolAd=item?.RolAd;
    this.UstKod=item?.UstKod;
    this.GenBelediye=item?.GenBelediye;
    this.GenBirim=item?.GenBirim;
    this.UstGenOrganizasyon=item?.UstGenOrganizasyon;
    this.GenOrganizasyons=item?.GenOrganizasyons;
    }
    }

export class SasHatBaglanti {

  AktifEh:string;
  BelediyeKod:number;
  DegisKullaniciKod?:number;
  DegisTarih?:Date;
  HatAciklama:string;
  HatAd:string;
  HatCab?:number;
  HatDerinlik?:number;
  KayitKullaniciKod:number;
  KayitTarih:Date;
  Kod:number;
  UstKod?:number;



  constructor(item?:any){
    this.AktifEh=item?.AktifEh;
    this.BelediyeKod=item?.BelediyeKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.HatAciklama=item?.HatAciklama;
    this.HatAd=item?.HatAd;
    this.HatCab=item?.HatCab;
    this.HatDerinlik=item?.HatDerinlik;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.UstKod=item?.UstKod;
  }
}






    export class GenRolMenuDetay {
    GenFormDetay:GenFormDetay;
    GenRolMenu:GenRolMenu;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    FormKod:number;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    MenuAnaKod:number;
    RolKod:number;
    YetkiAd:string;
    YetkiTur:string;

    constructor(item?:any){
    this.GenFormDetay=item?.GenFormDetay;
    this.GenRolMenu=item?.GenRolMenu;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.FormKod=item?.FormKod||0;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.MenuAnaKod=item?.MenuAnaKod||0;
    this.RolKod=item?.RolKod||0;
    this.YetkiAd=item?.YetkiAd||'';
    this.YetkiTur=item?.YetkiTur||'';
    }
    }

    export class GenViewKullanici {
    GenViewlar:GenViewlar;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih?:Date;
    Kod:number;
    KullaniciKodu:number;
    ViewAdi:string;

    constructor(item?:any){
    this.GenViewlar=item?.GenViewlar;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih;
    this.Kod=item?.Kod||0;
    this.KullaniciKodu=item?.KullaniciKodu||0;
    this.ViewAdi=item?.ViewAdi||'';
    }
    }

    export class GenAraziTuru {
    Aciklama:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;

    constructor(item?:any){
    this.Aciklama=item?.Aciklama||'';
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    }
    }

    export class GenAvukat {
    Ad?:string;
    Adres?:string;
    BelediyeKod:number;
    BitisTarih?:Date;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    Soyad?:string;
    Tckn?:number;
    GenBelediye:GenBelediye;

    constructor(item?:any){
    this.Ad=item?.Ad;
    this.Adres=item?.Adres;
    this.BelediyeKod=item?.BelediyeKod||0;
    this.BitisTarih=item?.BitisTarih;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.Soyad=item?.Soyad;
    this.Tckn=item?.Tckn;
    this.GenBelediye=item?.GenBelediye;
    }
    }

    export class GenBanka {
    Ad:string;
    BankaKodu:string;
    BelediyeKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    KisaAd:string;
    Kod:number;
    Kullanici?:string;
    KullaniciKod:number;
    KurumKodu?:string;
    Sifre?:string;
    VezneKod?:number;
    GenBelediye:GenBelediye;
    GenKullanici:GenKullanici;

    constructor(item?:any){
    this.Ad=item?.Ad||'';
    this.BankaKodu=item?.BankaKodu||'';
    this.BelediyeKod=item?.BelediyeKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.KisaAd=item?.KisaAd||'';
    this.Kod=item?.Kod||0;
    this.Kullanici=item?.Kullanici;
    this.KullaniciKod=item?.KullaniciKod||0;
    this.KurumKodu=item?.KurumKodu;
    this.Sifre=item?.Sifre;
    this.VezneKod=item?.VezneKod;
    this.GenBelediye=item?.GenBelediye;
    this.GenKullanici=item?.GenKullanici;
    }
    }

    export class GenBankaHata {
    Aciklama?:string;
    BelediyeKod?:number;
    DegerKod?:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih?:Date;
    Kod?:number;
    KodAmac?:string;
    Kodu?:string;

    constructor(item?:any){
    this.Aciklama=item?.Aciklama;
    this.BelediyeKod=item?.BelediyeKod;
    this.DegerKod=item?.DegerKod;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih;
    this.Kod=item?.Kod;
    this.KodAmac=item?.KodAmac;
    this.Kodu=item?.Kodu;
    }
    }

    export class GenBelediye {
    Aciklama:string;
    BelediyeKodu?:string;
    BelediyeResim?:number[];
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    IlceKod?:number;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    GenKullanicis:GenKullanici[];

    constructor(item?:any){
    this.Aciklama=item?.Aciklama||'';
    this.BelediyeKodu=item?.BelediyeKodu;
    this.BelediyeResim=item?.BelediyeResim;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.IlceKod=item?.IlceKod;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.GenKullanicis=item?.GenKullanicis;
    }
    }

    export class GenBelgeTip {
    Ad:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    Turu:number;
    Uzanti:string;

    constructor(item?:any){
    this.Ad=item?.Ad||'';
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.Turu=item?.Turu||0;
    this.Uzanti=item?.Uzanti||'';
    }
    }

    export class GenBinaKullanim {
    Ad:string;
    BelediyeKod:number;
    BinaKullanimGrupKod:number;
    CtvKullanimKod?:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KullanimSekliKod?:number;
    GenBelediye:GenBelediye;
    GenBinaKullanimGrup:GenBinaKullanimGrup;
    GenKullanimSekli?:GenKullanimSekli;

    constructor(item?:any){
    this.Ad=item?.Ad||'';
    this.BelediyeKod=item?.BelediyeKod||0;
    this.BinaKullanimGrupKod=item?.BinaKullanimGrupKod||0;
    this.CtvKullanimKod=item?.CtvKullanimKod;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KullanimSekliKod=item?.KullanimSekliKod;
    this.GenBelediye=item?.GenBelediye;
    this.GenBinaKullanimGrup=item?.GenBinaKullanimGrup;
    this.GenKullanimSekli=item?.GenKullanimSekli;
    }
    }

    export class GenBinaKullanimAna {
    Ad:string;
    BelediyeKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    GenBelediye:GenBelediye;
    GenBinaKullanimGrups:GenBinaKullanimGrup[];

    constructor(item?:any){
    this.Ad=item?.Ad||'';
    this.BelediyeKod=item?.BelediyeKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.GenBelediye=item?.GenBelediye;
    this.GenBinaKullanimGrups=item?.GenBinaKullanimGrups;
    }
    }

    export class GenBinaKullanimGrup {
    Ad:string;
    BelediyeKod:number;
    BinaKullanimAnaKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    GenBelediye:GenBelediye;
    GenBinaKullanims:GenBinaKullanim[];
    GenBinaKullanimAna:GenBinaKullanimAna;

    constructor(item?:any){
    this.Ad=item?.Ad||'';
    this.BelediyeKod=item?.BelediyeKod||0;
    this.BinaKullanimAnaKod=item?.BinaKullanimAnaKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.GenBelediye=item?.GenBelediye;
    this.GenBinaKullanims=item?.GenBinaKullanims;
    this.GenBinaKullanimAna=item?.GenBinaKullanimAna;
    }
    }

    export class GenBirim {
    Ad:string;
    KisaAd:string;
    AktifEh:string;
    AnaBirimKod?:number;
    BelediyeKod:number;
    BirimAdres?:string;
    BirimEPosta?:string;
    BirimTuru:string;
    BirimWebAdres?:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    EypPaketEh?:string;
    FaxAlanKod?:number;
    FaxNo?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    KepEposta?:string;
    KimlikNo:number;
    Kod:number;
    Notlar?:string;
    Seviye?:number;
    TelAlanKod?:number;
    TelNo?:string;
    UetsAdres?:string;
    YetkiliAdSoyad?:string;
    YetkiliPersonelKod?:number;
    YetkiliTelNo?:string;
    YetkiliUnvani?:string;
    AnaGenBirim?:GenBirim;
    GenBirims:GenBirim[];
    GenBirimIletisims:GenBirimIletisim[];

    constructor(item?:any){
    this.Ad=item?.Ad||'';
    this.KisaAd=item?.KisaAd||'';
    this.AktifEh=item?.AktifEh||'';
    this.AnaBirimKod=item?.AnaBirimKod || null;
    this.BelediyeKod=item?.BelediyeKod||0;
    this.BirimAdres=item?.BirimAdres;
    this.BirimEPosta=item?.BirimEPosta;
    this.BirimTuru=item?.BirimTuru||'';
    this.BirimWebAdres=item?.BirimWebAdres;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.EypPaketEh=item?.EypPaketEh;
    this.FaxAlanKod=item?.FaxAlanKod;
    this.FaxNo=item?.FaxNo;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.KepEposta=item?.KepEposta;
    this.KimlikNo=item?.KimlikNo||0;
    this.Kod=item?.Kod||0;
    this.Notlar=item?.Notlar;
    this.Seviye=item?.Seviye;
    this.TelAlanKod=item?.TelAlanKod;
    this.TelNo=item?.TelNo;
    this.UetsAdres=item?.UetsAdres;
    this.YetkiliAdSoyad=item?.YetkiliAdSoyad;
    this.YetkiliPersonelKod=item?.YetkiliPersonelKod;
    this.YetkiliTelNo=item?.YetkiliTelNo;
    this.YetkiliUnvani=item?.YetkiliUnvani;
    this.AnaGenBirim=item?.AnaGenBirim;
    this.GenBirims=item?.GenBirims;
    this.GenBirimIletisims=item?.GenBirimIletisims;
    }
    }

    export class GenBirimIletisim {
    Ad:string;
    AktifEh:string;
    BirimAdres?:string;
    BirimEPosta?:string;
    BirimKod?:number;
    BirimWebAdres?:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    FaxAlanKod?:number;
    FaxNo?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    Notlar?:string;
    TelAlanKod?:number;
    TelNo?:string;
    YetkiliAdSoyad?:string;
    YetkiliPersonelKod?:number;
    YetkiliTelNo?:string;
    YetkiliUnvani?:string;
    GenBirim?:GenBirim;

    constructor(item?:any){
    this.Ad=item?.Ad||'';
    this.AktifEh=item?.AktifEh||'';
    this.BirimAdres=item?.BirimAdres;
    this.BirimEPosta=item?.BirimEPosta;
    this.BirimKod=item?.BirimKod;
    this.BirimWebAdres=item?.BirimWebAdres;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.FaxAlanKod=item?.FaxAlanKod;
    this.FaxNo=item?.FaxNo;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.Notlar=item?.Notlar;
    this.TelAlanKod=item?.TelAlanKod;
    this.TelNo=item?.TelNo;
    this.YetkiliAdSoyad=item?.YetkiliAdSoyad;
    this.YetkiliPersonelKod=item?.YetkiliPersonelKod;
    this.YetkiliTelNo=item?.YetkiliTelNo;
    this.YetkiliUnvani=item?.YetkiliUnvani;
    this.GenBirim=item?.GenBirim;
    }
    }

    export class GenCaddeSokak {
    AcilisTarih?:Date;
    Ad:string;
    AktifEh:string;
    Alani?:number;
    AltyapiElektrikEh:string;
    AltyapiGazEh:string;
    AltyapiSuEh:string;
    AltyapiTelefonEh:string;
    AnaArterEh:string;
    BelediyeKod:number;
    CiftBaslangicNo?:number;
    CiftBitisNo?:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    Egim?:number;
    EskiAd?:string;
    Genislik?:number;
    HizLimiti?:number;
    KaldirimTurKod?:number;
    KapanisTarih?:Date;
    KaplamaTurKod?:number;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    MeclisKararNo?:string;
    MeclisKararTarih?:Date;
    ParkKapasitesi?:number;
    ParklamaEh:string;
    SeritSayisi?:number;
    TekBaslangicNo?:number;
    TekBitisNo?:number;
    TrafikYonu?:string;
    TurKod:number;
    Uzunluk?:number;
    YolAdiLevhasiEh:string;
    GenBelediye:GenBelediye;
    GenKodDetay?:GenKodDetay;
    GenKodDetay1?:GenKodDetay;
    GenKodDetay2:GenKodDetay;
    GenMahalleCaddeSokaks:GenMahalleCaddeSokak[];

    constructor(item?:any){
    this.AcilisTarih=item?.AcilisTarih;
    this.Ad=item?.Ad||'';
    this.AktifEh=item?.AktifEh||'';
    this.Alani=item?.Alani;
    this.AltyapiElektrikEh=item?.AltyapiElektrikEh||'';
    this.AltyapiGazEh=item?.AltyapiGazEh||'';
    this.AltyapiSuEh=item?.AltyapiSuEh||'';
    this.AltyapiTelefonEh=item?.AltyapiTelefonEh||'';
    this.AnaArterEh=item?.AnaArterEh||'';
    this.BelediyeKod=item?.BelediyeKod||0;
    this.CiftBaslangicNo=item?.CiftBaslangicNo;
    this.CiftBitisNo=item?.CiftBitisNo;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.Egim=item?.Egim;
    this.EskiAd=item?.EskiAd;
    this.Genislik=item?.Genislik;
    this.HizLimiti=item?.HizLimiti;
    this.KaldirimTurKod=item?.KaldirimTurKod;
    this.KapanisTarih=item?.KapanisTarih;
    this.KaplamaTurKod=item?.KaplamaTurKod;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.MeclisKararNo=item?.MeclisKararNo;
    this.MeclisKararTarih=item?.MeclisKararTarih;
    this.ParkKapasitesi=item?.ParkKapasitesi;
    this.ParklamaEh=item?.ParklamaEh||'';
    this.SeritSayisi=item?.SeritSayisi;
    this.TekBaslangicNo=item?.TekBaslangicNo;
    this.TekBitisNo=item?.TekBitisNo;
    this.TrafikYonu=item?.TrafikYonu;
    this.TurKod=item?.TurKod||0;
    this.Uzunluk=item?.Uzunluk;
    this.YolAdiLevhasiEh=item?.YolAdiLevhasiEh||'';
    this.GenBelediye=item?.GenBelediye;
    this.GenKodDetay=item?.GenKodDetay;
    this.GenKodDetay1=item?.GenKodDetay1;
    this.GenKodDetay2=item?.GenKodDetay2;
    this.GenMahalleCaddeSokaks=item?.GenMahalleCaddeSokaks;
    }
    }

    export class GenControl {
    ControlCode:string;
    ControlDescription:string;
    DefaultOrder?:string;
    DescriptionField:string;
    DlistCode:string;
    DonemYn:number;
    FilterColumns?:string;
    Kod:number;
    KodField:string;
    SearchColumns?:string;
    ValueField:string;

    constructor(item?:any){
    this.ControlCode=item?.ControlCode||'';
    this.ControlDescription=item?.ControlDescription||'';
    this.DefaultOrder=item?.DefaultOrder;
    this.DescriptionField=item?.DescriptionField||'';
    this.DlistCode=item?.DlistCode||'';
    this.DonemYn=item?.DonemYn||0;
    this.FilterColumns=item?.FilterColumns;
    this.Kod=item?.Kod||0;
    this.KodField=item?.KodField||'';
    this.SearchColumns=item?.SearchColumns;
    this.ValueField=item?.ValueField||'';
    }
    }

    export class GenDabKolon {
    AvgColLen?:number;
    CharacterSetName?:string;
    CharColDeclLength?:number;
    CharLength?:number;
    CharUsed?:string;
    ColumnId?:number;
    ColumnName:string;
    DataLength:number;
    DataPrecision?:number;
    DataScale?:number;
    DataType?:string;
    DataTypeMod?:string;
    DataTypeOwner?:string;
    DataUpgraded?:string;
    DefaultLength?:number;
    Density?:number;
    GlobalStats?:string;
    HighValue?:number[];
    Histogram?:string;
    LastAnalyzed?:Date;
    LowValue?:number[];
    Nullable?:string;
    NumBuckets?:number;
    NumDistinct?:number;
    NumNulls?:number;
    SampleSize?:number;
    TableName:string;
    UserStats?:string;
    V80FmtImage?:string;

    constructor(item?:any){
    this.AvgColLen=item?.AvgColLen;
    this.CharacterSetName=item?.CharacterSetName;
    this.CharColDeclLength=item?.CharColDeclLength;
    this.CharLength=item?.CharLength;
    this.CharUsed=item?.CharUsed;
    this.ColumnId=item?.ColumnId;
    this.ColumnName=item?.ColumnName||'';
    this.DataLength=item?.DataLength||0;
    this.DataPrecision=item?.DataPrecision;
    this.DataScale=item?.DataScale;
    this.DataType=item?.DataType;
    this.DataTypeMod=item?.DataTypeMod;
    this.DataTypeOwner=item?.DataTypeOwner;
    this.DataUpgraded=item?.DataUpgraded;
    this.DefaultLength=item?.DefaultLength;
    this.Density=item?.Density;
    this.GlobalStats=item?.GlobalStats;
    this.HighValue=item?.HighValue;
    this.Histogram=item?.Histogram;
    this.LastAnalyzed=item?.LastAnalyzed;
    this.LowValue=item?.LowValue;
    this.Nullable=item?.Nullable;
    this.NumBuckets=item?.NumBuckets;
    this.NumDistinct=item?.NumDistinct;
    this.NumNulls=item?.NumNulls;
    this.SampleSize=item?.SampleSize;
    this.TableName=item?.TableName||'';
    this.UserStats=item?.UserStats;
    this.V80FmtImage=item?.V80FmtImage;
    }
    }

    export class GenDinamikGrup {
    Ad:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih?:Date;
    Kod:number;
    GenDinamikGrupYetkis:GenDinamikGrupYetki[];

    constructor(item?:any){
    this.Ad=item?.Ad||'';
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih;
    this.Kod=item?.Kod||0;
    this.GenDinamikGrupYetkis=item?.GenDinamikGrupYetkis;
    }
    }

    export class GenDinamikGrupYetki {
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    GrupKod?:number;
    KayitKullaniciKod:number;
    KayitTarih?:Date;
    Kod:number;
    KullaniciKod?:number;
    GenDinamikGrup?:GenDinamikGrup;

    constructor(item?:any){
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.GrupKod=item?.GrupKod;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih;
    this.Kod=item?.Kod||0;
    this.KullaniciKod=item?.KullaniciKod;
    this.GenDinamikGrup=item?.GenDinamikGrup;
    }
    }

    export class GenDinamikSorgu {
    Ad?:string;
    BelediyeKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    GroupBy?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    Param?:string;
    Sorgu:string;
    Uygulamalar?:string;
    GenBelediye:GenBelediye;
    GenDinamikSorguYetkis:GenDinamikSorguYetki[];

    constructor(item?:any){
    this.Ad=item?.Ad;
    this.BelediyeKod=item?.BelediyeKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.GroupBy=item?.GroupBy;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.Param=item?.Param;
    this.Sorgu=item?.Sorgu||'';
    this.Uygulamalar=item?.Uygulamalar;
    this.GenBelediye=item?.GenBelediye;
    this.GenDinamikSorguYetkis=item?.GenDinamikSorguYetkis;
    }
    }

    export class GenDinamikSorguYetki {
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KullaniciKod:number;
    SorguKod:number;
    GenDinamikSorgu:GenDinamikSorgu;
    GenKullanici:GenKullanici;

    constructor(item?:any){
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KullaniciKod=item?.KullaniciKod||0;
    this.SorguKod=item?.SorguKod||0;
    this.GenDinamikSorgu=item?.GenDinamikSorgu;
    this.GenKullanici=item?.GenKullanici;
    }
    }

    export class GenDlist {
      AllowAddingYn?:number;
      AllowDeletingYn?:number;
      AllowExportpdfYn?:number;
      AllowExportxlsYn?:number;
      AllowFilterYn?:number;
      AllowGroupingYn?:number;
      AllowPagingYn?:number;
      AllowPivotYn?:number;
      AllowSearchYn?:number;
      AllowSelectionYn?:number;
      AllowStateYn?:number;
      AllowTotalbarYn?:number;
      AllowUpdatingYn?:number;
      BaseEntity?:string;
      ColumnChooserYn?:number;
      DlistCode:string;
      DlistName:string;
      DlistType?:string;
      EditMode?:string;
      HistoryEntity?:string;
      Id:number;
      LineCount?:number;
      MultilineHeaderYn?:number;
      MultilineItemYn?:number;
      OrderBy?:string;
      PageCount?:number;
      Params?:string;
      ShowActioncolumnYn?:number;
      ShowFilterYn?:number;
      ShowGroupingYn?:number;
      ShowPagingYn?:number;
      ShowSearchYn?:number;
      ShowSelectionYn?:number;
      ShowSettingYn?:number;
      ShowTotalbarYn?:number;
      GenDlistColumns:GenDlistColumn[];

      constructor(item?:any){
      this.AllowAddingYn=item?.AllowAddingYn;
      this.AllowDeletingYn=item?.AllowDeletingYn;
      this.AllowExportpdfYn=item?.AllowExportpdfYn;
      this.AllowExportxlsYn=item?.AllowExportxlsYn;
      this.AllowFilterYn=item?.AllowFilterYn;
      this.AllowGroupingYn=item?.AllowGroupingYn;
      this.AllowPagingYn=item?.AllowPagingYn;
      this.AllowPivotYn=item?.AllowPivotYn;
      this.AllowSearchYn=item?.AllowSearchYn;
      this.AllowSelectionYn=item?.AllowSelectionYn;
      this.AllowStateYn=item?.AllowStateYn;
      this.AllowTotalbarYn=item?.AllowTotalbarYn;
      this.AllowUpdatingYn=item?.AllowUpdatingYn;
      this.BaseEntity=item?.BaseEntity;
      this.ColumnChooserYn=item?.ColumnChooserYn;
      this.DlistCode=item?.DlistCode||'';
      this.DlistName=item?.DlistName||'';
      this.DlistType=item?.DlistType;
      this.EditMode=item?.EditMode;
      this.HistoryEntity=item?.HistoryEntity;
      this.Id=item?.Id||0;
      this.LineCount=item?.LineCount;
      this.MultilineHeaderYn=item?.MultilineHeaderYn;
      this.MultilineItemYn=item?.MultilineItemYn;
      this.OrderBy=item?.OrderBy;
      this.PageCount=item?.PageCount;
      this.Params=item?.Params;
      this.ShowActioncolumnYn=item?.ShowActioncolumnYn;
      this.ShowFilterYn=item?.ShowFilterYn;
      this.ShowGroupingYn=item?.ShowGroupingYn;
      this.ShowPagingYn=item?.ShowPagingYn;
      this.ShowSearchYn=item?.ShowSearchYn;
      this.ShowSelectionYn=item?.ShowSelectionYn;
      this.ShowSettingYn=item?.ShowSettingYn;
      this.ShowTotalbarYn=item?.ShowTotalbarYn;
      this.GenDlistColumns=item?.GenDlistColumns;
      }
      }


export class GenDlistColumn {
ActiveYn:number;
AllowFilterYn?:number;
AllowGroupYn?:number;
AllowHidingYn?:number;
AllowSortYn?:number;
DataField?:string;
DataLength?:number;
DataPrecision?:number;
DataScale?:number;
DataType?:string;
DefaultFilter?:string;
DefaultValue?:string;
DlistId?:number;
EditTemplate?:string;
EditYn?:number;
FixedPosition?:string;
FixedYn?:number;
Format?:string;
GroupIndex?:number;
Id:number;
LabelText?:string;
Lookup?:string;
Nullable?:string;
OrderIndex:number;
Pattern?:string;
PivotArea?:string;
PivotSummary?:string;
RefCode:string;
RequiredYn?:number;
SortIndex?:number;
SortOrder?:string;
Title:string;
TotalFormula?:string;
ViewTemplate?:string;
VisibleYn?:number;
Width:number;
GenDlist?:GenDlist;
EkStyle:string;
EoYn?:number;
EoHeight?:number;
EoMask?:string;
EoMax?:number;
EoMin?:number;
EoWidth?:number;
EoFormat?:string;


constructor(item?:any){
this.ActiveYn=item?.ActiveYn||0;
this.AllowFilterYn=item?.AllowFilterYn;
this.AllowGroupYn=item?.AllowGroupYn;
this.AllowHidingYn=item?.AllowHidingYn;
this.AllowSortYn=item?.AllowSortYn;
this.DataField=item?.DataField;
this.DataLength=item?.DataLength;
this.DataPrecision=item?.DataPrecision;
this.DataScale=item?.DataScale;
this.DataType=item?.DataType;
this.DefaultFilter=item?.DefaultFilter;
this.DefaultValue=item?.DefaultValue;
this.DlistId=item?.DlistId;
this.EditTemplate=item?.EditTemplate;
this.EditYn=item?.EditYn;
this.FixedPosition=item?.FixedPosition;
this.FixedYn=item?.FixedYn;
this.Format=item?.Format;
this.GroupIndex=item?.GroupIndex;
this.Id=item?.Id||0;
this.LabelText=item?.LabelText;
this.Lookup=item?.Lookup;
this.Nullable=item?.Nullable;
this.OrderIndex=item?.OrderIndex||0;
this.Pattern=item?.Pattern;
this.PivotArea=item?.PivotArea;
this.PivotSummary=item?.PivotSummary;
this.RefCode=item?.RefCode||'';
this.RequiredYn=item?.RequiredYn;
this.SortIndex=item?.SortIndex;
this.SortOrder=item?.SortOrder;
this.Title=item?.Title||'';
this.TotalFormula=item?.TotalFormula;
this.ViewTemplate=item?.ViewTemplate;
this.VisibleYn=item?.VisibleYn;
this.Width=item?.Width||0;
this.GenDlist=item?.GenDlist;
this.EkStyle=item?.EkStyle;
this.EoYn=item?.EoYn;
this.EoHeight=item?.EoHeight;
this.EoMask=item?.EoMask;
this.EoMax=item?.EoMax;
this.EoMin=item?.EoMin;
this.EoWidth=item?.EoWidth;

}
}

    export class GenDosyaPlan {
    Ad:string;
    BelediyeKod:number;
    Dayanak?:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    DosyaPlanKod:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    KlasorTuru?:string;
    Kod:number;
    KonuBoyut?:number;
    KonuTarihTuru?:string;
    KonuTuru?:string;
    SaklamaPlanKod?:number;
    Seviye?:number;
    Sure?:number;
    SureTuru?:string;
    TasfiyeIslemKod?:number;
    GenBelediye:GenBelediye;
    GenKodDetay?:GenKodDetay;

    constructor(item?:any){
    this.Ad=item?.Ad||'';
    this.BelediyeKod=item?.BelediyeKod||0;
    this.Dayanak=item?.Dayanak;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.DosyaPlanKod=item?.DosyaPlanKod||'';
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.KlasorTuru=item?.KlasorTuru;
    this.Kod=item?.Kod||0;
    this.KonuBoyut=item?.KonuBoyut;
    this.KonuTarihTuru=item?.KonuTarihTuru;
    this.KonuTuru=item?.KonuTuru;
    this.SaklamaPlanKod=item?.SaklamaPlanKod;
    this.Seviye=item?.Seviye;
    this.Sure=item?.Sure;
    this.SureTuru=item?.SureTuru;
    this.TasfiyeIslemKod=item?.TasfiyeIslemKod;
    this.GenBelediye=item?.GenBelediye;
    this.GenKodDetay=item?.GenKodDetay;
    }
    }

    export class GenFavori {
    Aciklama?:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    FormKod?:number;
    Icon?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KullaniciKod:number;
    Url?:string;
    GenForm?:GenForm;
    GenKullanici:GenKullanici;

    constructor(item?:any){
    this.Aciklama=item?.Aciklama;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.FormKod=item?.FormKod;
    this.Icon=item?.Icon;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KullaniciKod=item?.KullaniciKod||0;
    this.Url=item?.Url;
    this.GenForm=item?.GenForm;
    this.GenKullanici=item?.GenKullanici;
    }
    }

    export class GenForm {
    AnaDlistKod?:string;
    AnaDlistAd?:string;
    AppUrl?:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    DetayTakipEh?:string;
    FormAciklama:string;
    FormAd:string;
    FormKod?:string;
    FormTipi?:number;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    Url:string;
    GenFavoris:GenFavori[];
    GenFormDetays:GenFormDetay[];
    GenFormLogs:GenFormLog[];
    GenKullaniciMenuForms:GenKullaniciMenuForm[];
    GenMenus:GenMenu[];
    GenRaporLogs:GenRaporLog[];
    GenSikKullanilans:GenSikKullanilan[];

    constructor(item?:any){
    this.AnaDlistKod=item?.AnaDlistKod;
    this.AnaDlistAd=item?.AnaDlistAd;
    this.AppUrl=item?.AppUrl;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.DetayTakipEh =item?.DetayTakipEh;
    this.FormAciklama=item?.FormAciklama||'';
    this.FormAd=item?.FormAd||'';
    this.FormKod=item?.FormKod;
    this.FormTipi=item?.FormTipi;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.Url=item?.Url||'';
    this.GenFavoris=item?.GenFavoris;
    this.GenFormDetays=item?.GenFormDetays;
    this.GenFormLogs=item?.GenFormLogs;
    this.GenKullaniciMenuForms=item?.GenKullaniciMenuForms;
    this.GenMenus=item?.GenMenus;
    this.GenRaporLogs=item?.GenRaporLogs;
    this.GenSikKullanilans=item?.GenSikKullanilans;
    }
    }

    export class GenFormEntity{
      Kod?:number;
      FormKod?:number;
      EntityAd?:string;
      TestEh?:string;
      TestNot?:string;
      KayitTarih:string;
      KayitKullaniciKod:number;
      DegisTarih?:string;
      DegisKullaniciKod?:number;


      constructor(item?:any){
        this.Kod=item?.Kod||0;
        this.FormKod=item?.FormKod;
        this.EntityAd=item?.EntityAd;
        this.TestEh=item?.TestEh;
        this.TestNot=item?.TestNot;
        this.KayitTarih=item?.KayitTarih;
        this.KayitKullaniciKod=item?.KayitKullaniciKod;
        this.DegisTarih=item?.DegisTarih;
        this.DegisKullaniciKod=item?.DegisKullaniciKod;

      }

    }

export class GenFormYetki {
  DegisKullaniciKod?:number;
  DegisTarih?:Date;
  FormKod:number;
  KayitKullaniciKod:number;
  KayitTarih:Date;
  Kod:number;
  YetkiAciklama?:string;
  YetkiAd:string;
  YetkiTip:string;
  GenForm:GenForm;

  constructor(item?:any){
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.FormKod=item?.FormKod||0;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.YetkiAciklama=item?.YetkiAciklama;
    this.YetkiAd=item?.YetkiAd||'';
    this.YetkiTip=item?.YetkiTip||'';
    this.GenForm=item?.GenForm;
  }
}

export class GenFormIslem {
  AktifYn?:number;
  BStyle?:string;
  BStylingMode?:string;
  BTextVisibleYn?:number;
  BType?:string;
  BWitdh?:number;
  DabNot?:string;
  DegisKullaniciKod?:number;
  DegisTarih?:Date;
  DonemKontrolYn?:number;
  FormKod?:number;
  FormYer?:string;
  Icon?:string;
  IslemAd?:string;
  OrderIndex?:number;
  IslemBaslik?:string;
  IslemDetay?:string;
  IslemTipi?:string;
  KayitKullaniciKod:number;
  KayitTarih:Date;
  Kod:number;
  Status?:number;
  TestEh?:string;
  TestNot?:string;
  YetkiAd?:string;
  GenForm?:GenForm;
  constructor(item?:any){
  this.AktifYn=item?.AktifYn;
  this.BStyle=item?.BStyle;
  this.BStylingMode=item?.BStylingMode;
  this.BTextVisibleYn=item?.BTextVisibleYn;
  this.BType=item?.BType;
  this.BWitdh=item?.BWitdh;
  this.DabNot=item?.DabNot;
  this.DegisKullaniciKod=item?.DegisKullaniciKod;
  this.DegisTarih=item?.DegisTarih;
  this.DonemKontrolYn=item?.DonemKontrolYn;
  this.FormKod=item?.FormKod;
  this.FormYer=item?.FormYer;
  this.Icon=item?.Icon;
  this.IslemAd=item?.IslemAd;
  this.OrderIndex=item?.OrderIndex;
  this.IslemBaslik=item?.IslemBaslik;
  this.IslemDetay=item?.IslemDetay;
  this.IslemTipi=item?.IslemTipi;
  this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
  this.KayitTarih=item?.KayitTarih||new Date();
  this.Kod=item?.Kod||0;
  this.Status=item?.Status;
  this.TestEh=item?.TestEh;
  this.TestNot=item?.TestNot;
  this.YetkiAd=item?.YetkiAd;
  this.GenForm=item?.GenForm;
  }
  }

export class GenFormTest{
  Kod:number;
  FormKod:number;
  TestKod:string;
  TestAd:string;
  TestEh:string;
  TestNot:string;
  GenForm:GenForm;
  KayitTarih:string;
  KayitKullaniciKod:number;
  DegisTarih:string;
  DegisKullaniciKod:number;


  constructor(item?:any){
    this.Kod=item?.Kod||0;
    this.FormKod=item?.FormKod;
    this.TestKod=item?.TestKod;
    this.TestAd=item?.TestAd;
    this.TestEh=item?.TestEh;
    this.TestNot=item?.TestNot;
    this.GenForm=item?.GenForm;
    this.KayitTarih=item?.KayitTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
  }
}





    export class GenFormDetay {
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    FormKod:number;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    YetkiAciklama?:string;
    YetkiAd:string;
    YetkiTip:string;
    GenForm:GenForm;

    constructor(item?:any){
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.FormKod=item?.FormKod||0;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.YetkiAciklama=item?.YetkiAciklama;
    this.YetkiAd=item?.YetkiAd||'';
    this.YetkiTip=item?.YetkiTip||'';
    this.GenForm=item?.GenForm;
    }
    }


    export class GenFormLog {
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    FormKod?:number;
    HostName?:string;
    IpAdres?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KullaniciKod:number;
    Statu?:string;
    Turu?:string;
    GenForm?:GenForm;
    GenKullanici:GenKullanici;

    constructor(item?:any){
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.FormKod=item?.FormKod;
    this.HostName=item?.HostName;
    this.IpAdres=item?.IpAdres;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KullaniciKod=item?.KullaniciKod||0;
    this.Statu=item?.Statu;
    this.Turu=item?.Turu;
    this.GenForm=item?.GenForm;
    this.GenKullanici=item?.GenKullanici;
    }
    }

    export class GenHata {
    BlokAd?:string;
    DbmsHataAciklama?:string;
    DbmsHataKodu?:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    FirmayaIletildiEh:string;
    FormAd?:string;
    FormHataAciklama?:string;
    FormHataKodu?:string;
    ItemAd?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;

    constructor(item?:any){
    this.BlokAd=item?.BlokAd;
    this.DbmsHataAciklama=item?.DbmsHataAciklama;
    this.DbmsHataKodu=item?.DbmsHataKodu;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.FirmayaIletildiEh=item?.FirmayaIletildiEh||'';
    this.FormAd=item?.FormAd;
    this.FormHataAciklama=item?.FormHataAciklama;
    this.FormHataKodu=item?.FormHataKodu;
    this.ItemAd=item?.ItemAd;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    }
    }

    export class GenIl {
    Aciklama:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    GenIlces:GenIlce[];

    constructor(item?:any){
    this.Aciklama=item?.Aciklama||'';
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.GenIlces=item?.GenIlces;
    }
    }

    export class GenIlce {
    Aciklama:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    IlKod:number;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    NufusKodu?:number;
    GenBelediyes:GenBelediye[];
    GenIl:GenIl;

    constructor(item?:any){
    this.Aciklama=item?.Aciklama||'';
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.IlKod=item?.IlKod||0;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.NufusKodu=item?.NufusKodu;
    this.GenBelediyes=item?.GenBelediyes;
    this.GenIl=item?.GenIl;
    }
    }

    export class GenIletisimTuru {
    Ad?:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    Turu:number;
    GenKisiIletisims:GenKisiIletisim[];

    constructor(item?:any){
    this.Ad=item?.Ad;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.Turu=item?.Turu||0;
    this.GenKisiIletisims=item?.GenKisiIletisims;
    }
    }

    export class GenKisi {
      Aciklama?:string;
      Ad?:string;
      AnneAd?:string;
      BabaAd?:string;
      BelediyeKod:number;
      Cinsiyet?:string;
      DegisKullaniciKod?:number;
      DegisTarih?:Date;
      DiniKod?:number;
      DogumTarih?:Date;
      DogumYeriAciklama?:string;
      DogumYeriKod?:number;
      EhliyetNo?:string;
      EhliyetTarih?:Date;
      EhliyetTuruKod?:number;
      EmekliTarih?:Date;
      EmekliTuruKod?:number;
      IsyeriTuruKod?:number;
      KanGrubu?:string;
      KayitKullaniciKod:number;
      KayitTarih:Date;
      KisiTurKod:number;
      Kod:number;
      KpsKod?:string;
      KpsKontrolTarih?:Date;
      MedeniDurumKod?:number;
      MeslekAciklama?:string;
      MeslekKod?:number;
      NAileSiraNo?:string;
      NCiltNo?:string;
      NCuzdanKayitNo?:string;
      NCuzdanSeriNo?:string;
      NCuzdanSiraNo?:number;
      NCuzdanVerilisKod?:number;
      NIdaresiKod?:number;
      NKayitliMahalleKoy?:string;
      NKayitliYerKod?:number;
      NSiraNo?:string;
      NVerildigiTarih?:Date;
      OgrenimTuruKod?:number;
      OlumKapanisTarih?:Date;
      OncekiSoyad?:string;
      SicilKod:number;
      Soyad?:string;
      Tckn?:number;
      Unvani?:string;
      UyrukKod?:number;
      VarisEh?:string;
      VergiDairesi?:string;
      VergiNo?:string;
      GenIlceDogumYeri?:GenIlce;
      GenIlceNidaresi?:GenIlce;
      GenIlceNkayitliYer?:GenIlce;
      GenKisiAdres:GenKisiAdres[];
      GenKisiBirlesen:GenKisiBirles;
      GenKisiBirlestirilen:GenKisiBirles[];
      GenKisiIletisims:GenKisiIletisim[];
      GenKisiMesajs:GenKisiMesaj[];
      GenKisiResims:GenKisiResim[];
      GenKisiTuru:GenKisiTuru;
      GenKisiVaris:GenKisiVaris[];
      GenKisiYetkilis:GenKisiYetkili[];
      GenKisiYetkiliOlunans:GenKisiYetkili[];
      GenKodDini?:GenKodDetay;
      GenKodEhliyetTuru?:GenKodDetay;
      GenKodEmekliTuru?:GenKodDetay;
      GenKodIsyeriTuru?:GenKodDetay;
      GenKodMedeniDurum?:GenKodDetay;
      GenKodMeslek?:GenKodDetay;
      GenKodOgrenimTuru?:GenKodDetay;
      GenKodUyruk?:GenKodDetay;

      constructor(item?:any){
      this.Aciklama=item?.Aciklama;
      this.Ad=item?.Ad;
      this.AnneAd=item?.AnneAd;
      this.BabaAd=item?.BabaAd;
      this.BelediyeKod=item?.BelediyeKod||0;
      this.Cinsiyet=item?.Cinsiyet;
      this.DegisKullaniciKod=item?.DegisKullaniciKod;
      this.DegisTarih=item?.DegisTarih;
      this.DiniKod=item?.DiniKod;
      this.DogumTarih=item?.DogumTarih;
      this.DogumYeriAciklama=item?.DogumYeriAciklama;
      this.DogumYeriKod=item?.DogumYeriKod;
      this.EhliyetNo=item?.EhliyetNo;
      this.EhliyetTarih=item?.EhliyetTarih;
      this.EhliyetTuruKod=item?.EhliyetTuruKod;
      this.EmekliTarih=item?.EmekliTarih;
      this.EmekliTuruKod=item?.EmekliTuruKod;
      this.IsyeriTuruKod=item?.IsyeriTuruKod;
      this.KanGrubu=item?.KanGrubu;
      this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
      this.KayitTarih=item?.KayitTarih||new Date();
      this.KisiTurKod=item?.KisiTurKod||0;
      this.Kod=item?.Kod||0;
      this.KpsKod=item?.KpsKod;
      this.KpsKontrolTarih=item?.KpsKontrolTarih;
      this.MedeniDurumKod=item?.MedeniDurumKod;
      this.MeslekAciklama=item?.MeslekAciklama;
      this.MeslekKod=item?.MeslekKod;
      this.NAileSiraNo=item?.NAileSiraNo;
      this.NCiltNo=item?.NCiltNo;
      this.NCuzdanKayitNo=item?.NCuzdanKayitNo;
      this.NCuzdanSeriNo=item?.NCuzdanSeriNo;
      this.NCuzdanSiraNo=item?.NCuzdanSiraNo;
      this.NCuzdanVerilisKod=item?.NCuzdanVerilisKod;
      this.NIdaresiKod=item?.NIdaresiKod;
      this.NKayitliMahalleKoy=item?.NKayitliMahalleKoy;
      this.NKayitliYerKod=item?.NKayitliYerKod;
      this.NSiraNo=item?.NSiraNo;
      this.NVerildigiTarih=item?.NVerildigiTarih;
      this.OgrenimTuruKod=item?.OgrenimTuruKod;
      this.OlumKapanisTarih=item?.OlumKapanisTarih;
      this.OncekiSoyad=item?.OncekiSoyad;
      this.SicilKod=item?.SicilKod||0;
      this.Soyad=item?.Soyad;
      this.Tckn=item?.Tckn;
      this.Unvani=item?.Unvani;
      this.UyrukKod=item?.UyrukKod;
      this.VarisEh=item?.VarisEh;
      this.VergiDairesi=item?.VergiDairesi;
      this.VergiNo=item?.VergiNo;
      this.GenIlceDogumYeri=item?.GenIlceDogumYeri;
      this.GenIlceNidaresi=item?.GenIlceNidaresi;
      this.GenIlceNkayitliYer=item?.GenIlceNkayitliYer;
      this.GenKisiAdres=item?.GenKisiAdres;
      this.GenKisiBirlesen=item?.GenKisiBirlesen;
      this.GenKisiBirlestirilen=item?.GenKisiBirlestirilen;
      this.GenKisiIletisims=item?.GenKisiIletisims;
      this.GenKisiMesajs=item?.GenKisiMesajs;
      this.GenKisiResims=item?.GenKisiResims;
      this.GenKisiTuru=item?.GenKisiTuru;
      this.GenKisiVaris=item?.GenKisiVaris;
      this.GenKisiYetkilis=item?.GenKisiYetkilis;
      this.GenKisiYetkiliOlunans=item?.GenKisiYetkiliOlunans;
      this.GenKodDini=item?.GenKodDini;
      this.GenKodEhliyetTuru=item?.GenKodEhliyetTuru;
      this.GenKodEmekliTuru=item?.GenKodEmekliTuru;
      this.GenKodIsyeriTuru=item?.GenKodIsyeriTuru;
      this.GenKodMedeniDurum=item?.GenKodMedeniDurum;
      this.GenKodMeslek=item?.GenKodMeslek;
      this.GenKodOgrenimTuru=item?.GenKodOgrenimTuru;
      this.GenKodUyruk=item?.GenKodUyruk;
      }
      }

    export class GenKisiAdres {
    Aciklama?:string;
    AdresKapanisKod?:number;
    AktifEh:string;
    BlokNo?:string;
    BolumKod?:number;
    CaddeSokakAd?:string;
    DaireNo?:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    EskiKisiKod?:number;
    GelisTarih?:Date;
    GidisTarih?:Date;
    IlceKod?:number;
    KapiNo?:number;
    KapiNo1?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    KisiKod:number;
    Kod:number;
    MahalleAd?:string;
    MahalleCaddeKod:number;
    PostaKodu?:number;
    SiteApartmanAd?:string;
    TuikAdresKod?:number;
    Turu:string;
    YazismaEh:string;
    GenIlce?:GenIlce;
    GenKisi:GenKisi;
    GenKodAdresKapanis?:GenKodDetay;
    GenMahalleCaddeSokak?:GenMahalleCaddeSokak;

    constructor(item?:any){
    this.Aciklama=item?.Aciklama;
    this.AdresKapanisKod=item?.AdresKapanisKod;
    this.AktifEh=item?.AktifEh||'';
    this.BlokNo=item?.BlokNo;
    this.BolumKod=item?.BolumKod;
    this.CaddeSokakAd=item?.CaddeSokakAd;
    this.DaireNo=item?.DaireNo;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.EskiKisiKod=item?.EskiKisiKod;
    this.GelisTarih=item?.GelisTarih;
    this.GidisTarih=item?.GidisTarih;
    this.IlceKod=item?.IlceKod;
    this.KapiNo=item?.KapiNo;
    this.KapiNo1=item?.KapiNo1;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.KisiKod=item?.KisiKod||0;
    this.Kod=item?.Kod||0;
    this.MahalleAd=item?.MahalleAd;
    this.MahalleCaddeKod=item?.MahalleCaddeKod;
    this.PostaKodu=item?.PostaKodu;
    this.SiteApartmanAd=item?.SiteApartmanAd;
    this.TuikAdresKod=item?.TuikAdresKod;
    this.Turu=item?.Turu||'';
    this.YazismaEh=item?.YazismaEh||'';
    this.GenIlce=item?.GenIlce;
    this.GenKisi=item?.GenKisi;
    this.GenKodAdresKapanis=item?.GenKodAdresKapanis;
    this.GenMahalleCaddeSokak=item?.GenMahalleCaddeSokak;
    }
    }

    export class GenKisiBirles {
    BirlesenKisiKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    KisiKod:number;
    Kod:number;
    GenKisi:GenKisi;
    GenKisi1:GenKisi;

    constructor(item?:any){
    this.BirlesenKisiKod=item?.BirlesenKisiKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.KisiKod=item?.KisiKod||0;
    this.Kod=item?.Kod||0;
    this.GenKisi=item?.GenKisi;
    this.GenKisi1=item?.GenKisi1;
    }
    }

    export class GenKisiIletisim {
    AktifEh:string;
    AlanAd?:string;
    AlanKod?:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    EskiKisiKod?:number;
    IletisimTuruKod?:number;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    KisiKod:number;
    Kod:number;
    MailBilgiEh:string;
    MuhatapAd?:string;
    MuhatapSoyad?:string;
    Notlar?:string;
    SmsBilgiEh:string;
    GenIletisimTuru?:GenIletisimTuru;
    GenKisi:GenKisi;
    GenTelAlanKodlari?:GenTelAlanKodlari;

    constructor(item?:any){
    this.AktifEh=item?.AktifEh||'';
    this.AlanAd=item?.AlanAd;
    this.AlanKod=item?.AlanKod;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.EskiKisiKod=item?.EskiKisiKod;
    this.IletisimTuruKod=item?.IletisimTuruKod;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.KisiKod=item?.KisiKod||0;
    this.Kod=item?.Kod||0;
    this.MailBilgiEh=item?.MailBilgiEh||'';
    this.MuhatapAd=item?.MuhatapAd;
    this.MuhatapSoyad=item?.MuhatapSoyad;
    this.Notlar=item?.Notlar;
    this.SmsBilgiEh=item?.SmsBilgiEh||'';
    this.GenIletisimTuru=item?.GenIletisimTuru;
    this.GenKisi=item?.GenKisi;
    this.GenTelAlanKodlari=item?.GenTelAlanKodlari;
    }
    }

    export class GenKisiMesaj {
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    EskiKisiKod?:number;
    IslemTarih:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    KisaMesaj:string;
    KisiKod:number;
    Kod:number;
    Notlar?:string;
    GenKisi:GenKisi;

    constructor(item?:any){
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.EskiKisiKod=item?.EskiKisiKod;
    this.IslemTarih=item?.IslemTarih||new Date();
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.KisaMesaj=item?.KisaMesaj||'';
    this.KisiKod=item?.KisiKod||0;
    this.Kod=item?.Kod||0;
    this.Notlar=item?.Notlar;
    this.GenKisi=item?.GenKisi;
    }
    }

    export class GenKisiOtoNumara {
    BelediyeKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    KisiNo:number;
    Kod:number;
    GenBelediye:GenBelediye;

    constructor(item?:any){
    this.BelediyeKod=item?.BelediyeKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.KisiNo=item?.KisiNo||0;
    this.Kod=item?.Kod||0;
    this.GenBelediye=item?.GenBelediye;
    }
    }

    export class GenKisiResim {
    Aciklama?:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    EskiKisiKod?:number;
    IslemTarih:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    KisiKod:number;
    Kod:number;
    ResimDysKod?:string;
    ResimPath?:string;
    GenKisi:GenKisi;

    constructor(item?:any){
    this.Aciklama=item?.Aciklama;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.EskiKisiKod=item?.EskiKisiKod;
    this.IslemTarih=item?.IslemTarih||new Date();
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.KisiKod=item?.KisiKod||0;
    this.Kod=item?.Kod||0;
    this.ResimDysKod=item?.ResimDysKod;
    this.ResimPath=item?.ResimPath;
    this.GenKisi=item?.GenKisi;
    }
    }

    export class GenKisiTuru {
    Aciklama:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    Tur:string;

    constructor(item?:any){
    this.Aciklama=item?.Aciklama||'';
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.Tur=item?.Tur||'';
    }
    }

    export class GenKisiVaris {
    Adi:string;
    AktifEh:string;
    BabaAdi:string;
    BeyanVerenEh:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    DogumTarih?:Date;
    DogumYeriAciklama?:string;
    DogumYeriKod?:number;
    EskiKisiKod?:number;
    Hisse?:number;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    KisiKod:number;
    Kod:number;
    Oran?:number;
    Soyadi:string;
    TckimlikNo?:number;
    GenIlce?:GenIlce;
    GenKisi:GenKisi;

    constructor(item?:any){
    this.Adi=item?.Adi||'';
    this.AktifEh=item?.AktifEh||'';
    this.BabaAdi=item?.BabaAdi||'';
    this.BeyanVerenEh=item?.BeyanVerenEh||'';
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.DogumTarih=item?.DogumTarih;
    this.DogumYeriAciklama=item?.DogumYeriAciklama;
    this.DogumYeriKod=item?.DogumYeriKod;
    this.EskiKisiKod=item?.EskiKisiKod;
    this.Hisse=item?.Hisse;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.KisiKod=item?.KisiKod||0;
    this.Kod=item?.Kod||0;
    this.Oran=item?.Oran;
    this.Soyadi=item?.Soyadi||'';
    this.TckimlikNo=item?.TckimlikNo;
    this.GenIlce=item?.GenIlce;
    this.GenKisi=item?.GenKisi;
    }
    }

    export class GenKisiYetkili {
    AdiSoyadi?:string;
    AktifEh:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    EskiKisiKod?:number;
    EskiYetkiliKisiKod?:number;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    KisiKod:number;
    Kod:number;
    VekaletBaslaTarih:Date;
    VekaletBitisTarih?:Date;
    VekaletNo?:string;
    YetkiliKisiKod:number;
    YetkiliTuru?:string;
    GenKisi:GenKisi;
    GenKisiYetkiliOlan:GenKisi;

    constructor(item?:any){
    this.AdiSoyadi=item?.AdiSoyadi;
    this.AktifEh=item?.AktifEh||'';
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.EskiKisiKod=item?.EskiKisiKod;
    this.EskiYetkiliKisiKod=item?.EskiYetkiliKisiKod;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.KisiKod=item?.KisiKod||0;
    this.Kod=item?.Kod||0;
    this.VekaletBaslaTarih=item?.VekaletBaslaTarih||new Date();
    this.VekaletBitisTarih=item?.VekaletBitisTarih;
    this.VekaletNo=item?.VekaletNo;
    this.YetkiliKisiKod=item?.YetkiliKisiKod||0;
    this.YetkiliTuru=item?.YetkiliTuru;
    this.GenKisi=item?.GenKisi;
    this.GenKisiYetkiliOlan=item?.GenKisiYetkiliOlan;
    }
    }

    export class GenKodAna {
    Ad:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    GenKodDetays:GenKodDetay[];

    constructor(item?:any){
    this.Ad=item?.Ad||'';
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.GenKodDetays=item?.GenKodDetays;
    }
    }

    export class GenKodDetay {
    Ad:string;
    AnaKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    OzelKod?:number;
    OzelKodStr?:string;
    GenKisiAdres:GenKisiAdres[];
    GenKodAna:GenKodAna;

    constructor(item?:any){
    this.Ad=item?.Ad||'';
    this.AnaKod=item?.AnaKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.OzelKod=item?.OzelKod;
    this.OzelKodStr=item?.OzelKodStr;
    this.GenKisiAdres=item?.GenKisiAdres;
    this.GenKodAna=item?.GenKodAna;
    }
    }

    export class GenKpsAdres {
    Acikadres?:string;
    Adrestipi?:string;
    BelediyeKod:number;
    Beyandabulunankimlikno?:number;
    Beyantarihi?:Date;
    Binaada?:string;
    Binablokadi?:string;
    Binakodu?:number;
    Binapafta?:string;
    Binaparsel?:string;
    Binasiteadi?:string;
    Bucak?:string;
    Bucakkodu?:number;
    Csbm?:string;
    Csbmkodu?:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    Diskapino?:string;
    Hata?:string;
    Ickapino?:string;
    Ilad?:string;
    Ilcead?:string;
    Ilcekodu?:string;
    Ilkodu?:string;
    Ip?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    Koy?:string;
    Koykayitno?:number;
    Koykodu?:number;
    Mahalle?:string;
    Mahallekodu?:string;
    Tasinmatarihi?:Date;
    Tckn:string;
    Tesciltarihi?:Date;

    constructor(item?:any){
    this.Acikadres=item?.Acikadres;
    this.Adrestipi=item?.Adrestipi;
    this.BelediyeKod=item?.BelediyeKod||0;
    this.Beyandabulunankimlikno=item?.Beyandabulunankimlikno;
    this.Beyantarihi=item?.Beyantarihi;
    this.Binaada=item?.Binaada;
    this.Binablokadi=item?.Binablokadi;
    this.Binakodu=item?.Binakodu;
    this.Binapafta=item?.Binapafta;
    this.Binaparsel=item?.Binaparsel;
    this.Binasiteadi=item?.Binasiteadi;
    this.Bucak=item?.Bucak;
    this.Bucakkodu=item?.Bucakkodu;
    this.Csbm=item?.Csbm;
    this.Csbmkodu=item?.Csbmkodu;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.Diskapino=item?.Diskapino;
    this.Hata=item?.Hata;
    this.Ickapino=item?.Ickapino;
    this.Ilad=item?.Ilad;
    this.Ilcead=item?.Ilcead;
    this.Ilcekodu=item?.Ilcekodu;
    this.Ilkodu=item?.Ilkodu;
    this.Ip=item?.Ip;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.Koy=item?.Koy;
    this.Koykayitno=item?.Koykayitno;
    this.Koykodu=item?.Koykodu;
    this.Mahalle=item?.Mahalle;
    this.Mahallekodu=item?.Mahallekodu;
    this.Tasinmatarihi=item?.Tasinmatarihi;
    this.Tckn=item?.Tckn||'';
    this.Tesciltarihi=item?.Tesciltarihi;
    }
    }

    export class GenKpsKisi {
    Adi?:string;
    AileSiraNo?:number;
    AnneAdi?:string;
    BabaAdi?:string;
    BelediyeKod:number;
    BireySiraNo?:number;
    CiltNo?:number;
    Cinsiyeti?:string;
    CuzdanKayitNo?:string;
    CuzdanNo?:string;
    CuzdanSeriNo?:string;
    CuzdanVerilmeTarih?:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    DogumTarihi?:Date;
    DogumYeri?:string;
    DogumYeriIlceKod?:string;
    Hata?:string;
    Ip?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    MedeniDurumu?:string;
    NufusaKayitliIlceKod?:string;
    NufusIl?:string;
    NufusIlce?:string;
    NufusKoy?:string;
    OlumTarihi?:Date;
    Soyadi?:string;
    Tckn:number;
    Tur:string;
    VerildigiNufusIdareIlceKod?:string;

    constructor(item?:any){
    this.Adi=item?.Adi;
    this.AileSiraNo=item?.AileSiraNo;
    this.AnneAdi=item?.AnneAdi;
    this.BabaAdi=item?.BabaAdi;
    this.BelediyeKod=item?.BelediyeKod||0;
    this.BireySiraNo=item?.BireySiraNo;
    this.CiltNo=item?.CiltNo;
    this.Cinsiyeti=item?.Cinsiyeti;
    this.CuzdanKayitNo=item?.CuzdanKayitNo;
    this.CuzdanNo=item?.CuzdanNo;
    this.CuzdanSeriNo=item?.CuzdanSeriNo;
    this.CuzdanVerilmeTarih=item?.CuzdanVerilmeTarih;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.DogumTarihi=item?.DogumTarihi;
    this.DogumYeri=item?.DogumYeri;
    this.DogumYeriIlceKod=item?.DogumYeriIlceKod;
    this.Hata=item?.Hata;
    this.Ip=item?.Ip;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.MedeniDurumu=item?.MedeniDurumu;
    this.NufusaKayitliIlceKod=item?.NufusaKayitliIlceKod;
    this.NufusIl=item?.NufusIl;
    this.NufusIlce=item?.NufusIlce;
    this.NufusKoy=item?.NufusKoy;
    this.OlumTarihi=item?.OlumTarihi;
    this.Soyadi=item?.Soyadi;
    this.Tckn=item?.Tckn||0;
    this.Tur=item?.Tur||'';
    this.VerildigiNufusIdareIlceKod=item?.VerildigiNufusIdareIlceKod;
    }
    }

    export class GenKpsKisiAile {
    Adi?:string;
    AileSiraNo?:number;
    AnaKod?:number;
    AnneAdi?:string;
    BabaAdi?:string;
    BelediyeKod:number;
    BireySiraNo?:number;
    BosanmaTarihi?:Date;
    CiltNo?:number;
    Cinsiyeti?:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    DogumTarihi?:Date;
    DogumYeri?:string;
    DurumBilgisi?:string;
    EvlenmeTarihi?:Date;
    Hata?:string;
    Ip?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod?:number;
    MedeniDurumu?:string;
    NufusIl?:string;
    NufusIlce?:string;
    NufusKoy?:string;
    OlumTarihi?:Date;
    Soyadi?:string;
    Tckn:number;
    TescilTarihi?:Date;
    Tur?:string;
    YakinlikDurum?:string;

    constructor(item?:any){
    this.Adi=item?.Adi;
    this.AileSiraNo=item?.AileSiraNo;
    this.AnaKod=item?.AnaKod;
    this.AnneAdi=item?.AnneAdi;
    this.BabaAdi=item?.BabaAdi;
    this.BelediyeKod=item?.BelediyeKod||0;
    this.BireySiraNo=item?.BireySiraNo;
    this.BosanmaTarihi=item?.BosanmaTarihi;
    this.CiltNo=item?.CiltNo;
    this.Cinsiyeti=item?.Cinsiyeti;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.DogumTarihi=item?.DogumTarihi;
    this.DogumYeri=item?.DogumYeri;
    this.DurumBilgisi=item?.DurumBilgisi;
    this.EvlenmeTarihi=item?.EvlenmeTarihi;
    this.Hata=item?.Hata;
    this.Ip=item?.Ip;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod;
    this.MedeniDurumu=item?.MedeniDurumu;
    this.NufusIl=item?.NufusIl;
    this.NufusIlce=item?.NufusIlce;
    this.NufusKoy=item?.NufusKoy;
    this.OlumTarihi=item?.OlumTarihi;
    this.Soyadi=item?.Soyadi;
    this.Tckn=item?.Tckn||0;
    this.TescilTarihi=item?.TescilTarihi;
    this.Tur=item?.Tur;
    this.YakinlikDurum=item?.YakinlikDurum;
    }
    }

    export class GenKpsVedop {
    AcilisTarih?:Date;
    Adi?:string;
    BabaAdi?:string;
    BelediyeKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    FaalTerk?:string;
    Hata?:string;
    IkametCaddeSokakAd?:string;
    IkametDaireNo?:string;
    IkametIlceAd?:string;
    IkametIlKod?:string;
    IkametKapiNo?:string;
    IkametMahalleAd?:string;
    Ip?:string;
    IsCaddeSokakAd?:string;
    IsDaireNo?:string;
    IsIlceAd?:string;
    IsIlKod?:string;
    IsKapiNo?:string;
    IsMahalleAd?:string;
    KapanisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KullaniciTckn?:number;
    MeslekAd?:string;
    MeslekKod?:string;
    SirketTuru?:string;
    Soyadi?:string;
    TcknVergiNo:number;
    Tur:string;
    VergiDaire?:string;
    VergiDaireKod?:string;
    VergiNo?:string;

    constructor(item?:any){
    this.AcilisTarih=item?.AcilisTarih;
    this.Adi=item?.Adi;
    this.BabaAdi=item?.BabaAdi;
    this.BelediyeKod=item?.BelediyeKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.FaalTerk=item?.FaalTerk;
    this.Hata=item?.Hata;
    this.IkametCaddeSokakAd=item?.IkametCaddeSokakAd;
    this.IkametDaireNo=item?.IkametDaireNo;
    this.IkametIlceAd=item?.IkametIlceAd;
    this.IkametIlKod=item?.IkametIlKod;
    this.IkametKapiNo=item?.IkametKapiNo;
    this.IkametMahalleAd=item?.IkametMahalleAd;
    this.Ip=item?.Ip;
    this.IsCaddeSokakAd=item?.IsCaddeSokakAd;
    this.IsDaireNo=item?.IsDaireNo;
    this.IsIlceAd=item?.IsIlceAd;
    this.IsIlKod=item?.IsIlKod;
    this.IsKapiNo=item?.IsKapiNo;
    this.IsMahalleAd=item?.IsMahalleAd;
    this.KapanisTarih=item?.KapanisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KullaniciTckn=item?.KullaniciTckn;
    this.MeslekAd=item?.MeslekAd;
    this.MeslekKod=item?.MeslekKod;
    this.SirketTuru=item?.SirketTuru;
    this.Soyadi=item?.Soyadi;
    this.TcknVergiNo=item?.TcknVergiNo||0;
    this.Tur=item?.Tur||'';
    this.VergiDaire=item?.VergiDaire;
    this.VergiDaireKod=item?.VergiDaireKod;
    this.VergiNo=item?.VergiNo;
    }
    }

    export class GenKullanici {
    Adi:string;
    AktifEh:string;
    BelediyeKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    EkranRenk?:string;
    GoruntuRenk?:string;
    GrafikEh?:string;
    GuiId?:string;
    KayitKullaniciKod:number;
    KayitRenk?:string;
    KayitTarih:Date;
    Kod:number;
    KullaniciKod:string;
    KullaniciTip?:string;
    LdapEh?:string;
    LdapKullaniciAd?:string;
    PersonelKod?:number;
    Sifre:string;
    SifreGunu?:number;
    SifreTarihi?:Date;
    Soyadi:string;
    Tema:number;
    YaziRenk?:string;
    AesBolumKullaniciYetkis:GenAesBolumKullaniciYetki[];
    ArsBasvurus:GenArsBasvuru[];
    ArsBasvuruBirims:GenArsBasvuruBirim[];
    ArsBasvuruBirimDetays:GenArsBasvuruBirimDetay[];
    ArsBasvuruGorusmes:GenArsBasvuruGorusme[];
    ArsBirimKullanicis:GenArsBirimKullanici[];
    ArsKonuBirims:GenArsKonuBirim[];
    BysBirimKullaniciYetkis:GenBysBirimKullaniciYetki[];
    CmyBasvuruBirims:GenCmyBasvuruBirim[];
    CmyBasvuruBirimDetays:GenCmyBasvuruBirimDetay[];
    CmyBasvuruGorusmes:GenCmyBasvuruGorusme[];
    CmyBirimKullanicis:GenCmyBirimKullanici[];
    CmyCagriAgents:GenCmyCagriAgent[];
    CmyKonuBirims:GenCmyKonuBirim[];
    CmyKonuKullanicis:GenCmyKonuKullanici[];
    CmyMuhtar:GenCmyMuhtar;
    GasBirimDosyaYetkis:GenGasBirimDosyaYetki[];
    GasBirimKullaniciYetkis:GenGasBirimKullaniciYetki[];
    GenBankas:GenBanka[];
    GenBelediye:GenBelediye;
    GenDinamikSorguYetkis:GenDinamikSorguYetki[];
    GenFavoris:GenFavori[];
    GenFormLogs:GenFormLog[];
    GenKullaniciErisims:GenKullaniciErisim[];
    GenKullaniciRols:GenKullaniciRol[];
    GenKullaniciYazicis:GenKullaniciYazici[];
    GenTema:GenTema;
    GysGelirYetkis:GenGysGelirYetki[];
    IkaBirimKullanicis:GenIkaBirimKullanici[];
    IkaPersonel?:GenIkaPersonel;
    IkaPersonelTurYetkis:GenIkaPersonelTurYetki[];
    SysAmbarYetkis:GenSysAmbarYetki[];
    SysEkipDetays:GenSysEkipDetay[];
    SysYardimTurs:GenSysYardimTur[];
    SysYardimTurYetkis:GenSysYardimTurYetki[];
    TemDefterKullanicis:GenTemDefterKullanici[];
    TmsAmbarYetkis:GenTmsAmbarYetki[];
    TtsBasvurus:GenTtsBasvuru[];
    TtsBasvuruDetays:GenTtsBasvuruDetay[];
    TtsKullanicis:GenTtsKullanici[];

    constructor(item?:any){
    this.Adi=item?.Adi;
    this.AktifEh=item?.AktifEh;
    this.BelediyeKod=item?.BelediyeKod;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.EkranRenk=item?.EkranRenk;
    this.GoruntuRenk=item?.GoruntuRenk;
    this.GrafikEh=item?.GrafikEh;
    this.GuiId=item?.GuiId;
    this.KayitKullaniciKod=item?.KayitKullaniciKod;
    this.KayitRenk=item?.KayitRenk;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod;
    this.KullaniciKod=item?.KullaniciKod;
    this.KullaniciTip=item?.KullaniciTip;
    this.LdapEh=item?.LdapEh;
    this.LdapKullaniciAd=item?.LdapKullaniciAd;
    this.PersonelKod=item?.PersonelKod;
    this.Sifre=item?.Sifre;
    this.SifreGunu=item?.SifreGunu;
    this.SifreTarihi=item?.SifreTarihi;
    this.Soyadi=item?.Soyadi;
    this.Tema=item?.Tema;
    this.YaziRenk=item?.YaziRenk;
    this.AesBolumKullaniciYetkis=item?.AesBolumKullaniciYetkis;
    this.ArsBasvurus=item?.ArsBasvurus;
    this.ArsBasvuruBirims=item?.ArsBasvuruBirims;
    this.ArsBasvuruBirimDetays=item?.ArsBasvuruBirimDetays;
    this.ArsBasvuruGorusmes=item?.ArsBasvuruGorusmes;
    this.ArsBirimKullanicis=item?.ArsBirimKullanicis;
    this.ArsKonuBirims=item?.ArsKonuBirims;
    this.BysBirimKullaniciYetkis=item?.BysBirimKullaniciYetkis;
    this.CmyBasvuruBirims=item?.CmyBasvuruBirims;
    this.CmyBasvuruBirimDetays=item?.CmyBasvuruBirimDetays;
    this.CmyBasvuruGorusmes=item?.CmyBasvuruGorusmes;
    this.CmyBirimKullanicis=item?.CmyBirimKullanicis;
    this.CmyCagriAgents=item?.CmyCagriAgents;
    this.CmyKonuBirims=item?.CmyKonuBirims;
    this.CmyKonuKullanicis=item?.CmyKonuKullanicis;
    this.CmyMuhtar=item?.CmyMuhtar;
    this.GasBirimDosyaYetkis=item?.GasBirimDosyaYetkis;
    this.GasBirimKullaniciYetkis=item?.GasBirimKullaniciYetkis;
    this.GenBankas=item?.GenBankas;
    this.GenBelediye=item?.GenBelediye;
    this.GenDinamikSorguYetkis=item?.GenDinamikSorguYetkis;
    this.GenFavoris=item?.GenFavoris;
    this.GenFormLogs=item?.GenFormLogs;
    this.GenKullaniciErisims=item?.GenKullaniciErisims;
    this.GenKullaniciRols=item?.GenKullaniciRols;
    this.GenKullaniciYazicis=item?.GenKullaniciYazicis;
    this.GenTema=item?.GenTema;
    this.GysGelirYetkis=item?.GysGelirYetkis;
    this.IkaBirimKullanicis=item?.IkaBirimKullanicis;
    this.IkaPersonel=item?.IkaPersonel;
    this.IkaPersonelTurYetkis=item?.IkaPersonelTurYetkis;
    this.SysAmbarYetkis=item?.SysAmbarYetkis;
    this.SysEkipDetays=item?.SysEkipDetays;
    this.SysYardimTurs=item?.SysYardimTurs;
    this.SysYardimTurYetkis=item?.SysYardimTurYetkis;
    this.TemDefterKullanicis=item?.TemDefterKullanicis;
    this.TmsAmbarYetkis=item?.TmsAmbarYetkis;
    this.TtsBasvurus=item?.TtsBasvurus;
    this.TtsBasvuruDetays=item?.TtsBasvuruDetays;
    this.TtsKullanicis=item?.TtsKullanicis;
    }
    }

    export class GenKullaniciErisim {
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    ErisimKontrolTuru:string;
    IpAdres?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KullaniciKod:number;
    MakinaAd?:string;
    GenKullanici:GenKullanici;

    constructor(item?:any){
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.ErisimKontrolTuru=item?.ErisimKontrolTuru||'';
    this.IpAdres=item?.IpAdres;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KullaniciKod=item?.KullaniciKod||0;
    this.MakinaAd=item?.MakinaAd;
    this.GenKullanici=item?.GenKullanici;
    }
    }

    export class GenKullaniciForm {
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    FormAd?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:string;

    constructor(item?:any){
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.FormAd=item?.FormAd;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||'';
    }
    }

    export class GenKullaniciMenuForm {
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    FormKod:number;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KullaniciKod:number;
    PozisyonX:number;
    PozisyonY:number;
    GenForm:GenForm;

    constructor(item?:any){
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.FormKod=item?.FormKod||0;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KullaniciKod=item?.KullaniciKod||0;
    this.PozisyonX=item?.PozisyonX||0;
    this.PozisyonY=item?.PozisyonY||0;
    this.GenForm=item?.GenForm;
    }
    }

    export class GenKullaniciRol {
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KullaniciKod:number;
    RolKod:number;
    GenKullanici:GenKullanici;
    GenRol:GenRol;

    constructor(item?:any){
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KullaniciKod=item?.KullaniciKod||0;
    this.RolKod=item?.RolKod||0;
    this.GenKullanici=item?.GenKullanici;
    this.GenRol=item?.GenRol;
    }
    }

    export class GenKullaniciYazici {
    BelediyeKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KullaniciKod:number;
    ModulKod:number;
    Turu:string;
    YaziciAdi:string;
    GenBelediye:GenBelediye;
    GenKullanici:GenKullanici;
    GenModul:GenModul;

    constructor(item?:any){
    this.BelediyeKod=item?.BelediyeKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KullaniciKod=item?.KullaniciKod||0;
    this.ModulKod=item?.ModulKod||0;
    this.Turu=item?.Turu||'';
    this.YaziciAdi=item?.YaziciAdi||'';
    this.GenBelediye=item?.GenBelediye;
    this.GenKullanici=item?.GenKullanici;
    this.GenModul=item?.GenModul;
    }
    }

    export class GenKullanimSekli {
    Aciklama:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    IsyeriEh:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    GenBinaKullanims:GenBinaKullanim[];

    constructor(item?:any){
    this.Aciklama=item?.Aciklama||'';
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.IsyeriEh=item?.IsyeriEh||'';
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.GenBinaKullanims=item?.GenBinaKullanims;
    }
    }

    export class GenLog {
    BelediyeKod?:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    IslemTuru:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    ReferansKod:number;
    TabloAd:string;
    GenBelediye?:GenBelediye;
    GenLogDetays:GenLogDetay[];

    constructor(item?:any){
    this.BelediyeKod=item?.BelediyeKod;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.IslemTuru=item?.IslemTuru||'';
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.ReferansKod=item?.ReferansKod||0;
    this.TabloAd=item?.TabloAd||'';
    this.GenBelediye=item?.GenBelediye;
    this.GenLogDetays=item?.GenLogDetays;
    }
    }

    export class GenLogDetay {
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    EskiDeger?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KolonAd:string;
    LogKod:number;
    TabloAd:string;
    YeniDeger?:string;
    GenLog:GenLog;

    constructor(item?:any){
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.EskiDeger=item?.EskiDeger;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KolonAd=item?.KolonAd||'';
    this.LogKod=item?.LogKod||0;
    this.TabloAd=item?.TabloAd||'';
    this.YeniDeger=item?.YeniDeger;
    this.GenLog=item?.GenLog;
    }
    }

    export class GenLookup {
    Aciklama?:string;
    AnaKod?:number;
    AnaKodEh?:string;
    AnaKodName?:string;
    BelediyeKodEh?:string;
    DonemEh?:string;
    Kod:number;
    LookupKodu:string;
    Sorgu:string;

    constructor(item?:any){
    this.Aciklama=item?.Aciklama;
    this.AnaKod=item?.AnaKod;
    this.AnaKodEh=item?.AnaKodEh;
    this.AnaKodName=item?.AnaKodName;
    this.BelediyeKodEh=item?.BelediyeKodEh;
    this.DonemEh=item?.DonemEh;
    this.Kod=item?.Kod||0;
    this.LookupKodu=item?.LookupKodu||'';
    this.Sorgu=item?.Sorgu||'';
    }
    }

    export class GenMahalleCaddeSokak {
    AktifEh:string;
    CaddeSokakKod:number;
    CiftBaslangicNo?:number;
    CiftBitisNo?:number;
    CtvDerece?:number;
    CtvGrup?:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    GelismislikKod?:number;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    MahalleKod:number;
    TekBaslangicNo?:number;
    TekBitisNo?:number;
    TuikKod?:number;
    TuikTanitimNo?:number;
    GenCaddeSokak:GenCaddeSokak;
    GenKisiAdres:GenKisiAdres[];
    GenKodDetay?:GenKodDetay;
    GenMahalleKoy:GenMahalleKoy;

    constructor(item?:any){
    this.AktifEh=item?.AktifEh||'';
    this.CaddeSokakKod=item?.CaddeSokakKod||0;
    this.CiftBaslangicNo=item?.CiftBaslangicNo;
    this.CiftBitisNo=item?.CiftBitisNo;
    this.CtvDerece=item?.CtvDerece;
    this.CtvGrup=item?.CtvGrup;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.GelismislikKod=item?.GelismislikKod;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.MahalleKod=item?.MahalleKod||0;
    this.TekBaslangicNo=item?.TekBaslangicNo;
    this.TekBitisNo=item?.TekBitisNo;
    this.TuikKod=item?.TuikKod;
    this.TuikTanitimNo=item?.TuikTanitimNo;
    this.GenCaddeSokak=item?.GenCaddeSokak;
    this.GenKisiAdres=item?.GenKisiAdres;
    this.GenKodDetay=item?.GenKodDetay;
    this.GenMahalleKoy=item?.GenMahalleKoy;
    }
    }

    export class GenMahalleKoy {
    AcilisTarihi?:Date;
    Ad:string;
    AktifEh:string;
    BelediyeKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    IlceKod?:number;
    KapanisTarihi?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KoyEh:string;
    TuikMahalleKod?:number;
    TuikTanitimNo?:number;
    ParselNumaratajEh?:string;
    AdresNumaratajEh?:string;
    GenBelediye:GenBelediye;
    GenIlce?:GenIlce;
    GenMahalleCaddeSokaks:GenMahalleCaddeSokak[];

    constructor(item?:any){
    this.AcilisTarihi=item?.AcilisTarihi;
    this.Ad=item?.Ad||'';
    this.AktifEh=item?.AktifEh||'';
    this.BelediyeKod=item?.BelediyeKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.IlceKod=item?.IlceKod;
    this.KapanisTarihi=item?.KapanisTarihi;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KoyEh=item?.KoyEh||'';
    this.TuikMahalleKod=item?.TuikMahalleKod;
    this.TuikTanitimNo=item?.TuikTanitimNo;
    this.ParselNumaratajEh=item?.ParselNumaratajEh;
    this.AdresNumaratajEh=item?.AdresNumaratajEh;
    this.GenBelediye=item?.GenBelediye;
    this.GenIlce=item?.GenIlce;
    this.GenMahalleCaddeSokaks=item?.GenMahalleCaddeSokaks;
    }
    }

    export class GenMailOrderLog {
    AlmaTarih?:Date;
    BankaKod?:string;
    BelediyeKod?:number;
    Bloke?:string;
    Cevap?:string;
    CvcKod?:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    Dosya?:string;
    Ext?:number;
    Ftp?:string;
    GondermeTarih?:Date;
    Hata?:string;
    HesapNo?:string;
    HesapSahibiIsim?:string;
    HesapTip?:string;
    IslemSiraNo?:number;
    IslemTip?:string;
    KartTip?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    KisiKod?:number;
    Kod:number;
    KrediKartRid?:string;
    OrjTahkod?:string;
    OrjVade?:Date;
    SiparisNo?:string;
    SonKullanmaTarih?:Date;
    TahsilatRef?:number;
    Taksit?:number;
    Tutar?:number;
    Vade?:Date;

    constructor(item?:any){
    this.AlmaTarih=item?.AlmaTarih;
    this.BankaKod=item?.BankaKod;
    this.BelediyeKod=item?.BelediyeKod;
    this.Bloke=item?.Bloke;
    this.Cevap=item?.Cevap;
    this.CvcKod=item?.CvcKod;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.Dosya=item?.Dosya;
    this.Ext=item?.Ext;
    this.Ftp=item?.Ftp;
    this.GondermeTarih=item?.GondermeTarih;
    this.Hata=item?.Hata;
    this.HesapNo=item?.HesapNo;
    this.HesapSahibiIsim=item?.HesapSahibiIsim;
    this.HesapTip=item?.HesapTip;
    this.IslemSiraNo=item?.IslemSiraNo;
    this.IslemTip=item?.IslemTip;
    this.KartTip=item?.KartTip;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.KisiKod=item?.KisiKod;
    this.Kod=item?.Kod||0;
    this.KrediKartRid=item?.KrediKartRid;
    this.OrjTahkod=item?.OrjTahkod;
    this.OrjVade=item?.OrjVade;
    this.SiparisNo=item?.SiparisNo;
    this.SonKullanmaTarih=item?.SonKullanmaTarih;
    this.TahsilatRef=item?.TahsilatRef;
    this.Taksit=item?.Taksit;
    this.Tutar=item?.Tutar;
    this.Vade=item?.Vade;
    }
    }

    export class GenMailOrderXmlLog {
    BankaKod?:string;
    BelediyeKod?:number;
    Cevap?:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    Hata?:string;
    IslemTip?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    KisiKod?:number;
    Kod:number;
    OrderId?:string;
    RequestXml?:string;
    ResposeXml?:string;

    constructor(item?:any){
    this.BankaKod=item?.BankaKod;
    this.BelediyeKod=item?.BelediyeKod;
    this.Cevap=item?.Cevap;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.Hata=item?.Hata;
    this.IslemTip=item?.IslemTip;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.KisiKod=item?.KisiKod;
    this.Kod=item?.Kod||0;
    this.OrderId=item?.OrderId;
    this.RequestXml=item?.RequestXml;
    this.ResposeXml=item?.ResposeXml;
    }
    }

    export class GenMakbuzDeger {
    Aciklama?:string;
    ColumnAdi?:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    FormKod?:string;
    Icerik?:string;
    KayitKullaniciKod?:number;
    KayitTarih?:Date;
    Kod?:number;

    constructor(item?:any){
    this.Aciklama=item?.Aciklama;
    this.ColumnAdi=item?.ColumnAdi;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.FormKod=item?.FormKod;
    this.Icerik=item?.Icerik;
    this.KayitKullaniciKod=item?.KayitKullaniciKod;
    this.KayitTarih=item?.KayitTarih;
    this.Kod=item?.Kod;
    }
    }

    export class GenMatbu {
    Aciklama:string;
    BelediyeKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    MatbuAdi:string;
    NushaSayisi:number;
    SayfaBoyu:number;
    YaziciModu:number;
    GenBelediye:GenBelediye;
    GenMatbuDetays:GenMatbuDetay[];
    GenMatbuKolons:GenMatbuKolon[];

    constructor(item?:any){
    this.Aciklama=item?.Aciklama||'';
    this.BelediyeKod=item?.BelediyeKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.MatbuAdi=item?.MatbuAdi||'';
    this.NushaSayisi=item?.NushaSayisi||0;
    this.SayfaBoyu=item?.SayfaBoyu||0;
    this.YaziciModu=item?.YaziciModu||0;
    this.GenBelediye=item?.GenBelediye;
    this.GenMatbuDetays=item?.GenMatbuDetays;
    this.GenMatbuKolons=item?.GenMatbuKolons;
    }
    }

    export class GenMatbuDetay {
    Aciklama?:string;
    AlanAdi:string;
    BoldEh:string;
    Bosluk?:number;
    DbKolonEh:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    Format?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    MatbuKod:number;
    SatirAtla?:number;
    Sira?:number;
    Uzunluk?:number;
    YaslaTipi?:string;
    GenMatbu:GenMatbu;

    constructor(item?:any){
    this.Aciklama=item?.Aciklama;
    this.AlanAdi=item?.AlanAdi||'';
    this.BoldEh=item?.BoldEh||'';
    this.Bosluk=item?.Bosluk;
    this.DbKolonEh=item?.DbKolonEh||'';
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.Format=item?.Format;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.MatbuKod=item?.MatbuKod||0;
    this.SatirAtla=item?.SatirAtla;
    this.Sira=item?.Sira;
    this.Uzunluk=item?.Uzunluk;
    this.YaslaTipi=item?.YaslaTipi;
    this.GenMatbu=item?.GenMatbu;
    }
    }

    export class GenMatbuKolon {
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KolonAciklama?:string;
    KolonAdi:string;
    MatbuKod:number;
    GenMatbu:GenMatbu;
    GenMatbuKolonDegers:GenMatbuKolonDeger[];

    constructor(item?:any){
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KolonAciklama=item?.KolonAciklama;
    this.KolonAdi=item?.KolonAdi||'';
    this.MatbuKod=item?.MatbuKod||0;
    this.GenMatbu=item?.GenMatbu;
    this.GenMatbuKolonDegers=item?.GenMatbuKolonDegers;
    }
    }

    export class GenMatbuKolonDeger {
    BasilacakDeger:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    GelenDeger:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    MatbuKolonKod?:number;
    GenMatbuKolon?:GenMatbuKolon;

    constructor(item?:any){
    this.BasilacakDeger=item?.BasilacakDeger||'';
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.GelenDeger=item?.GelenDeger||'';
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.MatbuKolonKod=item?.MatbuKolonKod;
    this.GenMatbuKolon=item?.GenMatbuKolon;
    }
    }

    export class GenMenu {
    DabEh?:string;
    DabMenuAd?:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    Durum?:number;
    ExternalUrl?:string;
    FormKod?:number;
    Kademe?:number;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    MenuAd:string;
    MenuAnaKod:number;
    MenuIconUrl?:string;
    MenuParam?:string;
    SiraNo:number;
    UstKod?:number;
    GenForm?:GenForm;
    UstGenMenu?:GenMenu;
    GenMenus:GenMenu[];
    GenMenuAna:GenMenuAna;
    GenYardims:GenYardim[];

    constructor(item?:any){
    this.DabEh=item?.DabEh;
    this.DabMenuAd=item?.DabMenuAd;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.Durum=item?.Durum;
    this.ExternalUrl=item?.ExternalUrl;
    this.FormKod=item?.FormKod;
    this.Kademe=item?.Kademe;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.MenuAd=item?.MenuAd||'';
    this.MenuAnaKod=item?.MenuAnaKod;
    this.MenuIconUrl=item?.MenuIconUrl;
    this.MenuParam=item?.MenuParam;
    this.SiraNo=item?.SiraNo;
    this.UstKod=item?.UstKod;
    this.GenForm=item?.GenForm;
    this.UstGenMenu=item?.UstGenMenu;
    this.GenMenus=item?.GenMenus;
    this.GenMenuAna=item?.GenMenuAna;
    this.GenYardims=item?.GenYardims;
    }
    }

    export class GenMenuAna {
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    MenuAd:string;
    WebUrl?:string;
    GenMenus:GenMenu[];

    constructor(item?:any){
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.MenuAd=item?.MenuAd||'';
    this.WebUrl=item?.WebUrl;
    this.GenMenus=item?.GenMenus;
    }
    }

    export class GenMesajIptal {
    Aciklama?:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;

    constructor(item?:any){
    this.Aciklama=item?.Aciklama;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    }
    }

    export class GenMobilVatandas {
    BaslikAciklama:string;
    BaslikTip:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    GenelAciklama?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    Resim?:number[];
    SiraNo:number;
    Tarih?:Date;

    constructor(item?:any){
    this.BaslikAciklama=item?.BaslikAciklama||'';
    this.BaslikTip=item?.BaslikTip||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.GenelAciklama=item?.GenelAciklama;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.Resim=item?.Resim;
    this.SiraNo=item?.SiraNo||0;
    this.Tarih=item?.Tarih;
    }
    }

    export class GenModul {
    Ad:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    ModulUzantisi?:string;
    Tur:string;
    GysBeyans:GenGysBeyan[];

    constructor(item?:any){
    this.Ad=item?.Ad||'';
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.ModulUzantisi=item?.ModulUzantisi;
    this.Tur=item?.Tur||'';
    this.GysBeyans=item?.GysBeyans;
    }
    }

    export class GenOrganizasyonRol {
    AktifEh:string;
    BelediyeKod:number;
    BirimKod?:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    RolAciklama:string;
    RolAd:string;
    GenBelediye:GenBelediye;
    GenBirim?:GenBirim;

    constructor(item?:any){
    this.AktifEh=item?.AktifEh||'';
    this.BelediyeKod=item?.BelediyeKod||0;
    this.BirimKod=item?.BirimKod;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.RolAciklama=item?.RolAciklama||'';
    this.RolAd=item?.RolAd||'';
    this.GenBelediye=item?.GenBelediye;
    this.GenBirim=item?.GenBirim;
    }
    }

    export class GenParametre {
    BelediyeKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    EdevletKullanici?:string;
    EdevletSifre?:string;
    IslemDizin?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    KisiOtoEh:string;
    Kod:number;
    BelediyeIlceKod?:number;
    LoginSmsEh?:string;
    RaporBaslik1?:string;
    RaporBaslik2?:string;
    RaporBaslik3?:string;
    RaporBaslik4?:string;
    TcknKullanici?:string;
    TcknKullaniciSifre?:string;
    TcknServisUrl?:string;
    TcUyrukKod?:number;
    TkgmEh?:string;
    TkgmExePath?:string;
    TkgmKulKey?:string;
    TkgmKurumId?:number;
    UavtBeldeKodu?:number;
    UavtIlceKodu?:number;
    UavtKullanici?:string;
    UavtKullaniciSifre?:string;
    UavtServisUrl?:string;
    VarisAciklama?:string;
    VedopKullanici?:string;
    VedopSifre?:string;
    GenBelediye:GenBelediye;
    GenKodDetay?:GenKodDetay;

    constructor(item?:any){
    this.BelediyeKod=item?.BelediyeKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.EdevletKullanici=item?.EdevletKullanici;
    this.EdevletSifre=item?.EdevletSifre;
    this.IslemDizin=item?.IslemDizin;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.KisiOtoEh=item?.KisiOtoEh||'';
    this.Kod=item?.Kod||0;
    this.LoginSmsEh=item?.LoginSmsEh;
    this.RaporBaslik1=item?.RaporBaslik1;
    this.RaporBaslik2=item?.RaporBaslik2;
    this.RaporBaslik3=item?.RaporBaslik3;
    this.RaporBaslik4=item?.RaporBaslik4;
    this.TcknKullanici=item?.TcknKullanici;
    this.TcknKullaniciSifre=item?.TcknKullaniciSifre;
    this.TcknServisUrl=item?.TcknServisUrl;
    this.TcUyrukKod=item?.TcUyrukKod;
    this.TkgmEh=item?.TkgmEh;
    this.TkgmExePath=item?.TkgmExePath;
    this.TkgmKulKey=item?.TkgmKulKey;
    this.TkgmKurumId=item?.TkgmKurumId;
    this.UavtBeldeKodu=item?.UavtBeldeKodu;
    this.UavtIlceKodu=item?.UavtIlceKodu;
    this.UavtKullanici=item?.UavtKullanici;
    this.UavtKullaniciSifre=item?.UavtKullaniciSifre;
    this.UavtServisUrl=item?.UavtServisUrl;
    this.VarisAciklama=item?.VarisAciklama;
    this.VedopKullanici=item?.VedopKullanici;
    this.VedopSifre=item?.VedopSifre;
    this.GenBelediye=item?.GenBelediye;
    this.GenKodDetay=item?.GenKodDetay;
    this.BelediyeIlceKod=item?.BelediyeIlceKod;
    }
    }

    export class GenRaporImza {
    BelediyeKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    FormKod:number;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    RaporAciklama:string;
    RaporAdi:string;
    GenBelediye:GenBelediye;
    GenRaporImzaDetays:GenRaporImzaDetay[];

    constructor(item?:any){
    this.BelediyeKod=item?.BelediyeKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.FormKod=item?.FormKod||0;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.RaporAciklama=item?.RaporAciklama||'';
    this.RaporAdi=item?.RaporAdi||'';
    this.GenBelediye=item?.GenBelediye;
    this.GenRaporImzaDetays=item?.GenRaporImzaDetays;
    }
    }

    export class GenRaporImzaDetay {
    AktifEh:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    GorevAd?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    ParamDegeri?:string;
    Parametre?:string;
    PersonelKod?:number;
    RaporImzaKod:number;
    SiraNo:number;
    Turu?:string;
    UnvanKod?:number;
    GenRaporImza:GenRaporImza;

    constructor(item?:any){
    this.AktifEh=item?.AktifEh||'';
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.GorevAd=item?.GorevAd;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.ParamDegeri=item?.ParamDegeri;
    this.Parametre=item?.Parametre;
    this.PersonelKod=item?.PersonelKod;
    this.RaporImzaKod=item?.RaporImzaKod||0;
    this.SiraNo=item?.SiraNo||0;
    this.Turu=item?.Turu;
    this.UnvanKod=item?.UnvanKod;
    this.GenRaporImza=item?.GenRaporImza;
    }
    }

    export class GenRaporLog {
    BelediyeKod:number;
    BitisTarih?:Date;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    FormKod:number;
    IpAdres?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    RaporAd?:string;
    GenBelediye:GenBelediye;
    GenForm:GenForm;
    GenRaporLogDetays:GenRaporLogDetay[];

    constructor(item?:any){
    this.BelediyeKod=item?.BelediyeKod||0;
    this.BitisTarih=item?.BitisTarih;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.FormKod=item?.FormKod||0;
    this.IpAdres=item?.IpAdres;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.RaporAd=item?.RaporAd;
    this.GenBelediye=item?.GenBelediye;
    this.GenForm=item?.GenForm;
    this.GenRaporLogDetays=item?.GenRaporLogDetays;
    }
    }

    export class GenRaporLogDetay {
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KriterAd:string;
    KriterDeger?:string;
    RaporLogKod:number;
    GenRaporLog:GenRaporLog;

    constructor(item?:any){
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KriterAd=item?.KriterAd||'';
    this.KriterDeger=item?.KriterDeger;
    this.RaporLogKod=item?.RaporLogKod||0;
    this.GenRaporLog=item?.GenRaporLog;
    }
    }

    export class GenRaporParametre {
    BelediyeKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    HostName:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    ParametreAdi:string;
    ParametreDeger:string;
    GenBelediye:GenBelediye;

    constructor(item?:any){
    this.BelediyeKod=item?.BelediyeKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.HostName=item?.HostName||'';
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.ParametreAdi=item?.ParametreAdi||'';
    this.ParametreDeger=item?.ParametreDeger||'';
    this.GenBelediye=item?.GenBelediye;
    }
    }

    export class GenRaporTalep {
    Aciklama:string;
    BelediyeKod:number;
    BitisTarih?:Date;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    DosyaAdi:string;
    DosyaUzantisi:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    MailAdresi?:string;
    MailGoderildi?:string;
    RaporAdi:string;
    RaporKod:string;
    Status:string;
    GenBelediye:GenBelediye;

    constructor(item?:any){
    this.Aciklama=item?.Aciklama||'';
    this.BelediyeKod=item?.BelediyeKod||0;
    this.BitisTarih=item?.BitisTarih;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.DosyaAdi=item?.DosyaAdi||'';
    this.DosyaUzantisi=item?.DosyaUzantisi||'';
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.MailAdresi=item?.MailAdresi;
    this.MailGoderildi=item?.MailGoderildi;
    this.RaporAdi=item?.RaporAdi||'';
    this.RaporKod=item?.RaporKod||'';
    this.Status=item?.Status||'';
    this.GenBelediye=item?.GenBelediye;
    }
    }

    export class GenRaporTur {
    Ad:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    IconAd?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;

    constructor(item?:any){
    this.Ad=item?.Ad||'';
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.IconAd=item?.IconAd;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    }
    }

    export class GenReport {
    AktifEh:string;
    GorevEh:string;
    Id:number;
    MultiReportEh:string;
    OnlineEh:string;
    ReportBaslik:string;
    ReportGrupId?:number;
    ReportIcerik?:string;
    ReportKod:string;
    ReportUrl:string;
    ReportTipi:string;
    XCallerFormCount?:number;
    ZCallerRapCount?:number;
    ZMainReportName?:string;
    ZOrgRptName?:string;
    ZSubRptCount?:number;
    GenReportGrup?:GenReportGrup;
    GenReportParameters:GenReportParameter[];
    GenReportUrls:GenReportUrl[];

    constructor(item?:any){
    this.AktifEh=item?.AktifEh||'';
    this.GorevEh=item?.GorevEh||'';
    this.Id=item?.Id||0;
    this.MultiReportEh=item?.MultiReportEh||'';
    this.OnlineEh=item?.OnlineEh||'';
    this.ReportBaslik=item?.ReportBaslik||'';
    this.ReportGrupId=item?.ReportGrupId;
    this.ReportIcerik=item?.ReportIcerik;
    this.ReportKod=item?.ReportKod||'';
    this.ReportUrl=item?.ReportUrl||'';
    this.ReportTipi=item?.ReportTipi||'';
    this.XCallerFormCount=item?.XCallerFormCount;
    this.ZCallerRapCount=item?.ZCallerRapCount;
    this.ZMainReportName=item?.ZMainReportName;
    this.ZOrgRptName=item?.ZOrgRptName;
    this.ZSubRptCount=item?.ZSubRptCount;
    this.GenReportGrup=item?.GenReportGrup;
    this.GenReportParameters=item?.GenReportParameters;
    this.GenReportUrls=item?.GenReportUrls;
    }
    }

    export class GenReportGrup {
    Aciklama?:string;
    Id:number;
    ReportGrupKod?:string;
    GenReports:GenReport[];

    constructor(item?:any){
    this.Aciklama=item?.Aciklama;
    this.Id=item?.Id||0;
    this.ReportGrupKod=item?.ReportGrupKod;
    this.GenReports=item?.GenReports;
    }
    }

    export class GenReportParameter {
    CiktiDegeri?:string;
    GorunsunEh?:string;
    Grup?:string;
    Id:number;
    KolonSira?:number;
    MaxDeger?:string;
    MinDeger?:string;
    ParamBaslik:string;
    ParamKod:string;
    ParamTipi:string;
    ReportId:number;
    Sira?:number;
    TipParam1?:string;
    TipParam2?:string;
    TipParam3?:string;
    VarsayilanDeger?:string;
    ZorunluEh?:string;
    GenReport:GenReport;

    constructor(item?:any){
    this.CiktiDegeri=item?.CiktiDegeri;
    this.GorunsunEh=item?.GorunsunEh;
    this.Grup=item?.Grup;
    this.Id=item?.Id||0;
    this.KolonSira=item?.KolonSira;
    this.MaxDeger=item?.MaxDeger;
    this.MinDeger=item?.MinDeger;
    this.ParamBaslik=item?.ParamBaslik||'';
    this.ParamKod=item?.ParamKod||'';
    this.ParamTipi=item?.ParamTipi||'';
    this.ReportId=item?.ReportId||0;
    this.Sira=item?.Sira;
    this.TipParam1=item?.TipParam1;
    this.TipParam2=item?.TipParam2;
    this.TipParam3=item?.TipParam3;
    this.VarsayilanDeger=item?.VarsayilanDeger;
    this.ZorunluEh=item?.ZorunluEh;
    this.GenReport=item?.GenReport;
    }
    }

    export class GenReportUrl {
    AktifEh?:string;
    Id:number;
    ReportId?:number;
    ReportName?:string;
    ReportUrl?:string;
    GenReport?:GenReport;

    constructor(item?:any){
    this.AktifEh=item?.AktifEh;
    this.Id=item?.Id||0;
    this.ReportId=item?.ReportId;
    this.ReportName=item?.ReportName;
    this.ReportUrl=item?.ReportUrl;
    this.GenReport=item?.GenReport;
    }
    }

    export class GenRol {
    Ad:string;
    BelediyeKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    FormAciklama?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    Url?:string;
    GenBelediye:GenBelediye;
    GenKullaniciRols:GenKullaniciRol[];
    GenKullaniciRolYetkis:GenKullaniciRolYetki[];

    constructor(item?:any){
    this.Ad=item?.Ad||'';
    this.BelediyeKod=item?.BelediyeKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.FormAciklama=item?.FormAciklama;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.Url=item?.Url;
    this.GenBelediye=item?.GenBelediye;
    this.GenKullaniciRols=item?.GenKullaniciRols;
    this.GenKullaniciRolYetkis=item?.GenKullaniciRolYetkis;
    }
    }

export class GenRolForm {

  DegisKullaniciKod?:number;
  DegisTarih?:Date;
  FormKod:number;
  KayitKullaniciKod:number;
  KayitTarih:Date;
  Kod:number;
  MenuAnaKod?:number;
  RolKod?:number;
  GenBelediye:GenBelediye;
  GenKullaniciRols:GenKullaniciRol[];
  GenKullaniciRolYetkis:GenKullaniciRolYetki[];

  constructor(item?:any){
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.FormKod=item?.FormKod;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.MenuAnaKod=item?.MenuAnaKod;
    this.RolKod=item?.RolKod;
    this.GenBelediye=item?.GenBelediye;
    this.GenKullaniciRols=item?.GenKullaniciRols;
    this.GenKullaniciRolYetkis=item?.GenKullaniciRolYetkis;
  }
}

export class GenRolFormYetki {

  DegisKullaniciKod?:number;
  DegisTarih?:Date;
  FormKod:number;
  KayitKullaniciKod:number;
  KayitTarih:Date;
  Kod:number;
  MenuAnaKod?:number;
  RolKod?:number;
  YetkiAd?:string;
  YetkiTur?:string;
  GenBelediye:GenBelediye;
  GenKullaniciRols:GenKullaniciRol[];
  GenKullaniciRolYetkis:GenKullaniciRolYetki[];

  constructor(item?:any){
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.FormKod=item?.FormKod;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.MenuAnaKod=item?.MenuAnaKod;
    this.RolKod=item?.RolKod;
    this.YetkiAd=item?.YetkiAd;
    this.YetkiTur=item?.YetkiTur;
    this.GenBelediye=item?.GenBelediye;
    this.GenKullaniciRols=item?.GenKullaniciRols;
    this.GenKullaniciRolYetkis=item?.GenKullaniciRolYetkis;
  }
}







    export class GenRolMenu {
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    FormKod:number;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    MenuAnaKod:number;
    RolKod:number;

    constructor(item?:any){
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.FormKod=item?.FormKod||0;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.MenuAnaKod=item?.MenuAnaKod||0;
    this.RolKod=item?.RolKod||0;
    }
    }

    export class GenSetting {
    Aciklama?:string;
    BelediyeKod:number;
    Kategori:string;
    Kod:number;
    Modul:string;
    Param1?:string;
    Param2?:string;
    Param3?:string;
    SettingKey:string;
    SettingType:string;
    SettingValue:string;

    constructor(item?:any){
    this.Aciklama=item?.Aciklama;
    this.BelediyeKod=item?.BelediyeKod||0;
    this.Kategori=item?.Kategori||'';
    this.Kod=item?.Kod||0;
    this.Modul=item?.Modul||'';
    this.Param1=item?.Param1;
    this.Param2=item?.Param2;
    this.Param3=item?.Param3;
    this.SettingKey=item?.SettingKey||'';
    this.SettingType=item?.SettingType||'';
    this.SettingValue=item?.SettingValue||'';
    }
    }

    export class GenSikKullanilan {
    Aciklama?:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    FormKod:number;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KullaniciKod:number;
    GenForm:GenForm;

    constructor(item?:any){
    this.Aciklama=item?.Aciklama;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.FormKod=item?.FormKod||0;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KullaniciKod=item?.KullaniciKod||0;
    this.GenForm=item?.GenForm;
    }
    }

    export class GenSms {
    BelediyeKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    GonderimDurum?:string;
    GonderimTarih?:Date;
    GsmNo?:string;
    HataKod?:number;
    IletimDurumu?:number;
    IletimTarih?:Date;
    IslemTuru?:number;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    Metin?:string;
    TakipDurum?:number;
    TakipKod?:number;
    Tckn?:number;
    GenBelediye:GenBelediye;

    constructor(item?:any){
    this.BelediyeKod=item?.BelediyeKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.GonderimDurum=item?.GonderimDurum;
    this.GonderimTarih=item?.GonderimTarih;
    this.GsmNo=item?.GsmNo;
    this.HataKod=item?.HataKod;
    this.IletimDurumu=item?.IletimDurumu;
    this.IletimTarih=item?.IletimTarih;
    this.IslemTuru=item?.IslemTuru;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.Metin=item?.Metin;
    this.TakipDurum=item?.TakipDurum;
    this.TakipKod=item?.TakipKod;
    this.Tckn=item?.Tckn;
    this.GenBelediye=item?.GenBelediye;
    }
    }

    export class GenSmsTur {
    Aciklama:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;

    constructor(item?:any){
    this.Aciklama=item?.Aciklama||'';
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    }
    }

    export class GenTatilGun {
    BelediyeKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    Gun:Date;
    GunTuru:number;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    GenBelediye:GenBelediye;

    constructor(item?:any){
    this.BelediyeKod=item?.BelediyeKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.Gun=item?.Gun||new Date();
    this.GunTuru=item?.GunTuru||0;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.GenBelediye=item?.GenBelediye;
    }
    }

    export class GenTelAlanKodlari {
    Aciklama?:string;
    AlanKod:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    GsmEh:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;

    constructor(item?:any){
    this.Aciklama=item?.Aciklama;
    this.AlanKod=item?.AlanKod||'';
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.GsmEh=item?.GsmEh||'';
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    }
    }

    export class GenTema {
    Aciklama:string;
    BodyClass:string;
    CanvasClass?:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    FrameRenk1:string;
    FrameRenk2:string;
    GuiClass?:string;
    HeaderClass:string;
    KayitKullaniciKod:number;
    KayitTarih?:Date;
    Kod:number;
    Renk:string;
    TitleClass:string;
    GenKullanicis:GenKullanici[];

    constructor(item?:any){
    this.Aciklama=item?.Aciklama||'';
    this.BodyClass=item?.BodyClass||'';
    this.CanvasClass=item?.CanvasClass;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.FrameRenk1=item?.FrameRenk1||'';
    this.FrameRenk2=item?.FrameRenk2||'';
    this.GuiClass=item?.GuiClass;
    this.HeaderClass=item?.HeaderClass||'';
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih;
    this.Kod=item?.Kod||0;
    this.Renk=item?.Renk||'';
    this.TitleClass=item?.TitleClass||'';
    this.GenKullanicis=item?.GenKullanicis;
    }
    }

    export class GenTkgmKisi {
    Ad?:string;
    Aile?:string;
    Aktif?:string;
    AlimBaslamaSekliAd?:string;
    AlimIslemTanimAd?:string;
    AlimKod?:number;
    AnaAdi?:string;
    BabaAdi?:string;
    Cilt?:string;
    Cinsiyet?:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    DogumTarih?:string;
    DogumYeri?:string;
    EdinmeSebep?:string;
    EvlilikOncesiSoyadi?:string;
    HissePay?:number;
    HissePayda?:number;
    IstirakNo?:number;
    KayitKullaniciKod:number;
    KayitTarih?:Date;
    KisiId?:number;
    KisiTip?:string;
    Kod:number;
    Mahalle?:string;
    NufusaKayitliOlduguIl?:string;
    NufusaKayitliOlduguIlce?:string;
    SicilNo?:string;
    Sira?:string;
    SorguKod:number;
    Soyadi?:string;
    Tckn?:string;
    TerkinBaslamaSekliAd?:string;
    TerkinIslemTanimAd?:string;
    TerkinKod?:number;
    TerkinYevmiyeNo?:number;
    TerkinYevmiyeTarih?:string;
    VergiNo?:string;
    YevmiyeNo?:number;
    YevmiyeTarih?:string;
    ZeminHisseid?:number;
    ZeminKod:number;
    GenTkgmSerhRehins:GenTkgmSerhRehin[];
    GenTkgmZemin:GenTkgmZemin;

    constructor(item?:any){
    this.Ad=item?.Ad;
    this.Aile=item?.Aile;
    this.Aktif=item?.Aktif;
    this.AlimBaslamaSekliAd=item?.AlimBaslamaSekliAd;
    this.AlimIslemTanimAd=item?.AlimIslemTanimAd;
    this.AlimKod=item?.AlimKod;
    this.AnaAdi=item?.AnaAdi;
    this.BabaAdi=item?.BabaAdi;
    this.Cilt=item?.Cilt;
    this.Cinsiyet=item?.Cinsiyet;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.DogumTarih=item?.DogumTarih;
    this.DogumYeri=item?.DogumYeri;
    this.EdinmeSebep=item?.EdinmeSebep;
    this.EvlilikOncesiSoyadi=item?.EvlilikOncesiSoyadi;
    this.HissePay=item?.HissePay;
    this.HissePayda=item?.HissePayda;
    this.IstirakNo=item?.IstirakNo;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih;
    this.KisiId=item?.KisiId;
    this.KisiTip=item?.KisiTip;
    this.Kod=item?.Kod||0;
    this.Mahalle=item?.Mahalle;
    this.NufusaKayitliOlduguIl=item?.NufusaKayitliOlduguIl;
    this.NufusaKayitliOlduguIlce=item?.NufusaKayitliOlduguIlce;
    this.SicilNo=item?.SicilNo;
    this.Sira=item?.Sira;
    this.SorguKod=item?.SorguKod||0;
    this.Soyadi=item?.Soyadi;
    this.Tckn=item?.Tckn;
    this.TerkinBaslamaSekliAd=item?.TerkinBaslamaSekliAd;
    this.TerkinIslemTanimAd=item?.TerkinIslemTanimAd;
    this.TerkinKod=item?.TerkinKod;
    this.TerkinYevmiyeNo=item?.TerkinYevmiyeNo;
    this.TerkinYevmiyeTarih=item?.TerkinYevmiyeTarih;
    this.VergiNo=item?.VergiNo;
    this.YevmiyeNo=item?.YevmiyeNo;
    this.YevmiyeTarih=item?.YevmiyeTarih;
    this.ZeminHisseid=item?.ZeminHisseid;
    this.ZeminKod=item?.ZeminKod||0;
    this.GenTkgmSerhRehins=item?.GenTkgmSerhRehins;
    this.GenTkgmZemin=item?.GenTkgmZemin;
    }
    }

    export class GenTkgmSerhRehin {
    Aciklama?:string;
    BaslamaSekilAd?:string;
    Birim?:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    Faiz?:string;
    IslemTanimAd?:string;
    KayitKullaniciKod:number;
    KayitTarih?:Date;
    KisiKod:number;
    Kod:number;
    KrediTip?:string;
    Kurum?:string;
    Miktar?:number;
    RehinTip?:string;
    SorguKod:number;
    Turu:number;
    Vade?:string;
    YevmiyeNo?:string;
    YevmiyeTarih?:string;
    ZeminKod:number;
    GenTkgmKisi:GenTkgmKisi;

    constructor(item?:any){
    this.Aciklama=item?.Aciklama;
    this.BaslamaSekilAd=item?.BaslamaSekilAd;
    this.Birim=item?.Birim;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.Faiz=item?.Faiz;
    this.IslemTanimAd=item?.IslemTanimAd;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih;
    this.KisiKod=item?.KisiKod||0;
    this.Kod=item?.Kod||0;
    this.KrediTip=item?.KrediTip;
    this.Kurum=item?.Kurum;
    this.Miktar=item?.Miktar;
    this.RehinTip=item?.RehinTip;
    this.SorguKod=item?.SorguKod||0;
    this.Turu=item?.Turu||0;
    this.Vade=item?.Vade;
    this.YevmiyeNo=item?.YevmiyeNo;
    this.YevmiyeTarih=item?.YevmiyeTarih;
    this.ZeminKod=item?.ZeminKod||0;
    this.GenTkgmKisi=item?.GenTkgmKisi;
    }
    }

    export class GenTkgmSorgu {
    Ada?:string;
    Aktif?:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    IlceKod?:number;
    Ip?:string;
    KayitKullaniciKod:number;
    KayitTarih?:Date;
    Kod:number;
    Kulkey:string;
    KullaniciKod?:number;
    MahalleKod?:number;
    Pafta?:string;
    Parsel?:string;
    SerhRehin?:string;
    SorguTuru:string;
    Tckn?:string;
    GenTkgmZemins:GenTkgmZemin[];

    constructor(item?:any){
    this.Ada=item?.Ada;
    this.Aktif=item?.Aktif;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.IlceKod=item?.IlceKod;
    this.Ip=item?.Ip;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih;
    this.Kod=item?.Kod||0;
    this.Kulkey=item?.Kulkey||'';
    this.KullaniciKod=item?.KullaniciKod;
    this.MahalleKod=item?.MahalleKod;
    this.Pafta=item?.Pafta;
    this.Parsel=item?.Parsel;
    this.SerhRehin=item?.SerhRehin;
    this.SorguTuru=item?.SorguTuru||'';
    this.Tckn=item?.Tckn;
    this.GenTkgmZemins=item?.GenTkgmZemins;
    }
    }

    export class GenTkgmZemin {
    Ada?:string;
    Alan?:string;
    CiltNo?:string;
    DegisKullaniciKod?:string;
    DegisTarih?:string;
    DmhAlan?:string;
    DmhNitelik?:string;
    KatArsaPay?:string;
    KatArsaPayda?:string;
    KatBagBolNo?:string;
    KatBagBolTip?:string;
    KatBlok?:string;
    KatGiris?:string;
    KatKat?:string;
    KatNitelik?:string;
    KayitKullaniciKod:string;
    KayitTarih?:string;
    Kod:number;
    MahalleKod?:number;
    Mevkii?:string;
    Nitelik?:string;
    Pafta?:string;
    ParselId?:string;
    SayfaNo?:string;
    SorguKod:number;
    ZeminId?:string;
    ZeminTip?:string;
    GenTkgmKisis:GenTkgmKisi[];
    GenTkgmSorgu:GenTkgmSorgu;

    constructor(item?:any){
    this.Ada=item?.Ada;
    this.Alan=item?.Alan;
    this.CiltNo=item?.CiltNo;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.DmhAlan=item?.DmhAlan;
    this.DmhNitelik=item?.DmhNitelik;
    this.KatArsaPay=item?.KatArsaPay;
    this.KatArsaPayda=item?.KatArsaPayda;
    this.KatBagBolNo=item?.KatBagBolNo;
    this.KatBagBolTip=item?.KatBagBolTip;
    this.KatBlok=item?.KatBlok;
    this.KatGiris=item?.KatGiris;
    this.KatKat=item?.KatKat;
    this.KatNitelik=item?.KatNitelik;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||'';
    this.KayitTarih=item?.KayitTarih;
    this.Kod=item?.Kod||0;
    this.MahalleKod=item?.MahalleKod;
    this.Mevkii=item?.Mevkii;
    this.Nitelik=item?.Nitelik;
    this.Pafta=item?.Pafta;
    this.ParselId=item?.ParselId;
    this.SayfaNo=item?.SayfaNo;
    this.SorguKod=item?.SorguKod||0;
    this.ZeminId=item?.ZeminId;
    this.ZeminTip=item?.ZeminTip;
    this.GenTkgmKisis=item?.GenTkgmKisis;
    this.GenTkgmSorgu=item?.GenTkgmSorgu;
    }
    }

    export class GenUlke {
    Ad:string;
    AlanKod?:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    Plaka?:string;
    UyrukKod?:number;
    GenKodDetay?:GenKodDetay;

    constructor(item?:any){
    this.Ad=item?.Ad||'';
    this.AlanKod=item?.AlanKod;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.Plaka=item?.Plaka;
    this.UyrukKod=item?.UyrukKod;
    this.GenKodDetay=item?.GenKodDetay;
    }
    }

    export class GenUyari {
    Aciklama:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    Tipi:string;

    constructor(item?:any){
    this.Aciklama=item?.Aciklama||'';
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.Tipi=item?.Tipi||'';
    }
    }

    export class GenViewlar {
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    GrupKod:number;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    ViewAciklama:string;
    ViewAdi:string;

    constructor(item?:any){
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.GrupKod=item?.GrupKod||0;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.ViewAciklama=item?.ViewAciklama||'';
    this.ViewAdi=item?.ViewAdi||'';
    }
    }

    export class GenVposBorc {
    BeyanAdres?:string;
    BeyanKod?:number;
    BorcGecikmeFaiz?:number;
    BorcVergi?:number;
    DetayGelirAd?:string;
    DetayGelirKod?:number;
    Donem?:number;
    EkVergiEh?:string;
    GecikmeKod?:number;
    GecikmeZammi?:number;
    GelirKod?:number;
    HkpBeyanKod?:number;
    HkpIsKod?:number;
    IndirimTutar?:number;
    ModulKod?:number;
    Provizyon:string;
    ReferansAltKod?:number;
    ReferansKod?:number;
    SiraNo?:number;
    SuAboneKod?:number;
    SuOkumaKod?:number;
    TahakkukKod?:number;
    TakipliEh?:string;
    TaksitKod?:number;
    VadeTarih?:Date;
    Yil?:number;

    constructor(item?:any){
    this.BeyanAdres=item?.BeyanAdres;
    this.BeyanKod=item?.BeyanKod;
    this.BorcGecikmeFaiz=item?.BorcGecikmeFaiz;
    this.BorcVergi=item?.BorcVergi;
    this.DetayGelirAd=item?.DetayGelirAd;
    this.DetayGelirKod=item?.DetayGelirKod;
    this.Donem=item?.Donem;
    this.EkVergiEh=item?.EkVergiEh;
    this.GecikmeKod=item?.GecikmeKod;
    this.GecikmeZammi=item?.GecikmeZammi;
    this.GelirKod=item?.GelirKod;
    this.HkpBeyanKod=item?.HkpBeyanKod;
    this.HkpIsKod=item?.HkpIsKod;
    this.IndirimTutar=item?.IndirimTutar;
    this.ModulKod=item?.ModulKod;
    this.Provizyon=item?.Provizyon||'';
    this.ReferansAltKod=item?.ReferansAltKod;
    this.ReferansKod=item?.ReferansKod;
    this.SiraNo=item?.SiraNo;
    this.SuAboneKod=item?.SuAboneKod;
    this.SuOkumaKod=item?.SuOkumaKod;
    this.TahakkukKod=item?.TahakkukKod;
    this.TakipliEh=item?.TakipliEh;
    this.TaksitKod=item?.TaksitKod;
    this.VadeTarih=item?.VadeTarih;
    this.Yil=item?.Yil;
    }
    }

    export class GenVposHata {
    Aciklama?:string;
    KayitTarih?:Date;
    Provizyon:string;

    constructor(item?:any){
    this.Aciklama=item?.Aciklama;
    this.KayitTarih=item?.KayitTarih;
    this.Provizyon=item?.Provizyon||'';
    }
    }

    export class GenVposIslem {
    BankaTuru3D?:string;
    Clientid3D?:string;
    KayitTarih?:Date;
    Link3D?:string;
    Provizyon:string;
    Sifre3D?:string;
    Termcustemail3D?:string;
    Termerchid3D?:string;
    Termprovid3D?:string;
    Termuserid3D?:string;

    constructor(item?:any){
    this.BankaTuru3D=item?.BankaTuru3D;
    this.Clientid3D=item?.Clientid3D;
    this.KayitTarih=item?.KayitTarih;
    this.Link3D=item?.Link3D;
    this.Provizyon=item?.Provizyon||'';
    this.Sifre3D=item?.Sifre3D;
    this.Termcustemail3D=item?.Termcustemail3D;
    this.Termerchid3D=item?.Termerchid3D;
    this.Termprovid3D=item?.Termprovid3D;
    this.Termuserid3D=item?.Termuserid3D;
    }
    }

    export class GenVposMailOrder {
    BankaKod?:string;
    Bankakodu?:string;
    BankaSubeKod?:string;
    BelediyeKod?:number;
    Cavv?:string;
    Clientip?:string;
    CvcKod?:string;
    Doviz?:string;
    Eci?:string;
    HesapNo?:string;
    HesapSahibiIsim?:string;
    HesapTip?:string;
    HesapTur?:string;
    IptalReferansNo?:number;
    IslemTip?:string;
    KimlikNo?:string;
    KimlikTip?:string;
    KisiKod?:number;
    Kullanicikodu?:string;
    Kur?:number;
    Maskedpan?:string;
    Md?:string;
    Mderrormsg?:string;
    Mdstatus?:string;
    Provizyon:string;
    Sifre?:string;
    SifreliCvcKod?:string;
    SifreliHesapNo?:string;
    SifreliSonKulTarih?:string;
    SonKullanmaTarih?:Date;
    Subekodu?:string;
    Subekullanicikodu?:string;
    TahsilatKod?:string;
    ToplamTutar?:number;
    ToplamTutarTl?:number;
    Txstatus?:string;
    Xid?:string;

    constructor(item?:any){
    this.BankaKod=item?.BankaKod;
    this.Bankakodu=item?.Bankakodu;
    this.BankaSubeKod=item?.BankaSubeKod;
    this.BelediyeKod=item?.BelediyeKod;
    this.Cavv=item?.Cavv;
    this.Clientip=item?.Clientip;
    this.CvcKod=item?.CvcKod;
    this.Doviz=item?.Doviz;
    this.Eci=item?.Eci;
    this.HesapNo=item?.HesapNo;
    this.HesapSahibiIsim=item?.HesapSahibiIsim;
    this.HesapTip=item?.HesapTip;
    this.HesapTur=item?.HesapTur;
    this.IptalReferansNo=item?.IptalReferansNo;
    this.IslemTip=item?.IslemTip;
    this.KimlikNo=item?.KimlikNo;
    this.KimlikTip=item?.KimlikTip;
    this.KisiKod=item?.KisiKod;
    this.Kullanicikodu=item?.Kullanicikodu;
    this.Kur=item?.Kur;
    this.Maskedpan=item?.Maskedpan;
    this.Md=item?.Md;
    this.Mderrormsg=item?.Mderrormsg;
    this.Mdstatus=item?.Mdstatus;
    this.Provizyon=item?.Provizyon||'';
    this.Sifre=item?.Sifre;
    this.SifreliCvcKod=item?.SifreliCvcKod;
    this.SifreliHesapNo=item?.SifreliHesapNo;
    this.SifreliSonKulTarih=item?.SifreliSonKulTarih;
    this.SonKullanmaTarih=item?.SonKullanmaTarih;
    this.Subekodu=item?.Subekodu;
    this.Subekullanicikodu=item?.Subekullanicikodu;
    this.TahsilatKod=item?.TahsilatKod;
    this.ToplamTutar=item?.ToplamTutar;
    this.ToplamTutarTl=item?.ToplamTutarTl;
    this.Txstatus=item?.Txstatus;
    this.Xid=item?.Xid;
    }
    }

    export class GenVposOrderCevap {
    BankaTuru3D?:string;
    Cevapaciklama?:string;
    Cevapkodu?:string;
    Clientid3D?:string;
    IslemRef?:string;
    IslemTar?:Date;
    Link3D?:string;
    Provizyon:string;
    ReferansNo?:number;
    Sifre3D?:string;
    Termcustemail3D?:string;
    Termerchid3D?:string;
    Termprovid3D?:string;
    Termuserid3D?:string;

    constructor(item?:any){
    this.BankaTuru3D=item?.BankaTuru3D;
    this.Cevapaciklama=item?.Cevapaciklama;
    this.Cevapkodu=item?.Cevapkodu;
    this.Clientid3D=item?.Clientid3D;
    this.IslemRef=item?.IslemRef;
    this.IslemTar=item?.IslemTar;
    this.Link3D=item?.Link3D;
    this.Provizyon=item?.Provizyon||'';
    this.ReferansNo=item?.ReferansNo;
    this.Sifre3D=item?.Sifre3D;
    this.Termcustemail3D=item?.Termcustemail3D;
    this.Termerchid3D=item?.Termerchid3D;
    this.Termprovid3D=item?.Termprovid3D;
    this.Termuserid3D=item?.Termuserid3D;
    }
    }

    export class GenWebKisi {
    Ad?:string;
    AdresBlokNo?:string;
    AdresCaddeSokakAd?:string;
    AdresDaireNo?:string;
    AdresIlceKod?:number;
    AdresKapiNo?:number;
    AdresKapiNo1?:string;
    AdresMahalleAd?:string;
    AdresMahalleCaddeKod?:number;
    AdresPostaKodu?:number;
    AdresSiteApartmanAd?:string;
    AdresTuru:string;
    AnneAd?:string;
    BabaAd?:string;
    BasvuruTuru:number;
    BelediyeKod:number;
    Cinsiyet?:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    DiniKod?:number;
    DogumTarih?:Date;
    DogumYeriAciklama?:string;
    DogumYeriKod?:number;
    EMail?:string;
    FaxAlanKod?:number;
    FaxNo?:number;
    GsmAlanKod?:number;
    GsmNo?:number;
    KanGrubu?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    KisiKod?:number;
    Kod:number;
    MedeniDurumKod?:number;
    MeslekAciklama?:string;
    MeslekKod?:number;
    OgrenimTuruKod?:number;
    OnayDurumu:string;
    Sifre?:string;
    SifreHatirlatmaCevap?:string;
    SifreHatirlatmaSoru?:number;
    Soyad?:string;
    Tckn?:number;
    TelAlanKod?:number;
    TelNo?:number;
    Unvani?:string;
    UyrukKod?:number;
    VergiDairesi?:string;
    VergiNo?:string;
    GenBelediye:GenBelediye;
    GenIlce?:GenIlce;
    GenIlce1?:GenIlce;
    GenKodDetay?:GenKodDetay;
    GenKodDetay1?:GenKodDetay;
    GenKodDetay2?:GenKodDetay;
    GenKodDetay3?:GenKodDetay;
    GenKodDetay4?:GenKodDetay;
    GenMahalleCaddeSokak?:GenMahalleCaddeSokak;
    GenTelAlanKodlari?:GenTelAlanKodlari;
    GenTelAlanKodlari1?:GenTelAlanKodlari;
    GenTelAlanKodlari2?:GenTelAlanKodlari;

    constructor(item?:any){
    this.Ad=item?.Ad;
    this.AdresBlokNo=item?.AdresBlokNo;
    this.AdresCaddeSokakAd=item?.AdresCaddeSokakAd;
    this.AdresDaireNo=item?.AdresDaireNo;
    this.AdresIlceKod=item?.AdresIlceKod;
    this.AdresKapiNo=item?.AdresKapiNo;
    this.AdresKapiNo1=item?.AdresKapiNo1;
    this.AdresMahalleAd=item?.AdresMahalleAd;
    this.AdresMahalleCaddeKod=item?.AdresMahalleCaddeKod;
    this.AdresPostaKodu=item?.AdresPostaKodu;
    this.AdresSiteApartmanAd=item?.AdresSiteApartmanAd;
    this.AdresTuru=item?.AdresTuru||'';
    this.AnneAd=item?.AnneAd;
    this.BabaAd=item?.BabaAd;
    this.BasvuruTuru=item?.BasvuruTuru||0;
    this.BelediyeKod=item?.BelediyeKod||0;
    this.Cinsiyet=item?.Cinsiyet;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.DiniKod=item?.DiniKod;
    this.DogumTarih=item?.DogumTarih;
    this.DogumYeriAciklama=item?.DogumYeriAciklama;
    this.DogumYeriKod=item?.DogumYeriKod;
    this.EMail=item?.EMail;
    this.FaxAlanKod=item?.FaxAlanKod;
    this.FaxNo=item?.FaxNo;
    this.GsmAlanKod=item?.GsmAlanKod;
    this.GsmNo=item?.GsmNo;
    this.KanGrubu=item?.KanGrubu;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.KisiKod=item?.KisiKod;
    this.Kod=item?.Kod||0;
    this.MedeniDurumKod=item?.MedeniDurumKod;
    this.MeslekAciklama=item?.MeslekAciklama;
    this.MeslekKod=item?.MeslekKod;
    this.OgrenimTuruKod=item?.OgrenimTuruKod;
    this.OnayDurumu=item?.OnayDurumu||'';
    this.Sifre=item?.Sifre;
    this.SifreHatirlatmaCevap=item?.SifreHatirlatmaCevap;
    this.SifreHatirlatmaSoru=item?.SifreHatirlatmaSoru;
    this.Soyad=item?.Soyad;
    this.Tckn=item?.Tckn;
    this.TelAlanKod=item?.TelAlanKod;
    this.TelNo=item?.TelNo;
    this.Unvani=item?.Unvani;
    this.UyrukKod=item?.UyrukKod;
    this.VergiDairesi=item?.VergiDairesi;
    this.VergiNo=item?.VergiNo;
    this.GenBelediye=item?.GenBelediye;
    this.GenIlce=item?.GenIlce;
    this.GenIlce1=item?.GenIlce1;
    this.GenKodDetay=item?.GenKodDetay;
    this.GenKodDetay1=item?.GenKodDetay1;
    this.GenKodDetay2=item?.GenKodDetay2;
    this.GenKodDetay3=item?.GenKodDetay3;
    this.GenKodDetay4=item?.GenKodDetay4;
    this.GenMahalleCaddeSokak=item?.GenMahalleCaddeSokak;
    this.GenTelAlanKodlari=item?.GenTelAlanKodlari;
    this.GenTelAlanKodlari1=item?.GenTelAlanKodlari1;
    this.GenTelAlanKodlari2=item?.GenTelAlanKodlari2;
    }
    }

    export class GenWebParametre {
    BelediyeKod?:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KullaniciKod?:number;

    constructor(item?:any){
    this.BelediyeKod=item?.BelediyeKod;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KullaniciKod=item?.KullaniciKod;
    }
    }

    export class GenYardim {
    AnaMenuKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    Icerik?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    MenuKod?:number;
    GenMenu?:GenMenu;

    constructor(item?:any){
    this.AnaMenuKod=item?.AnaMenuKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.Icerik=item?.Icerik;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.MenuKod=item?.MenuKod;
    this.GenMenu=item?.GenMenu;
    }
    }

    export class GenAtsAmbarGiris {
    Adet?:number;
    AmbarKod:number;
    BelediyeKod:number;
    BirimFiyat?:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    EskiKisiKod?:number;
    FaturaNo?:string;
    FaturaTarih?:Date;
    GenelTutar?:number;
    GirisTarih:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    KdvOran?:number;
    KdvTutar?:number;
    KisiKod?:number;
    Kod:number;
    MalzemeAd?:string;
    MalzemeKod?:string;
    Notlar?:string;
    TeslimEden?:string;
    ToplamTutar?:number;

    constructor(item?:any){
    this.Adet=item?.Adet;
    this.AmbarKod=item?.AmbarKod||0;
    this.BelediyeKod=item?.BelediyeKod||0;
    this.BirimFiyat=item?.BirimFiyat;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.EskiKisiKod=item?.EskiKisiKod;
    this.FaturaNo=item?.FaturaNo;
    this.FaturaTarih=item?.FaturaTarih;
    this.GenelTutar=item?.GenelTutar;
    this.GirisTarih=item?.GirisTarih||new Date();
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.KdvOran=item?.KdvOran;
    this.KdvTutar=item?.KdvTutar;
    this.KisiKod=item?.KisiKod;
    this.Kod=item?.Kod||0;
    this.MalzemeAd=item?.MalzemeAd;
    this.MalzemeKod=item?.MalzemeKod;
    this.Notlar=item?.Notlar;
    this.TeslimEden=item?.TeslimEden;
    this.ToplamTutar=item?.ToplamTutar;
    }
    }

    export class GenGysBeyan {
    Aciklama?:string;
    Ada?:number;
    AraziTurKod?:number;
    ArsaAlani?:number;
    ArsaAlani1?:number;
    ArsaHisse?:number;
    ArsaHisse1?:number;
    ArsaOran?:number;
    ArsaOran1?:number;
    AsgariHesapYil?:number;
    BelediyeKod:number;
    BeyanTipi:number;
    BildirimSekli:string;
    BinaAsansorEh?:string;
    BinaHisse?:number;
    BinaHisse1?:number;
    BinaKaloriferEh?:string;
    BinaKod?:number;
    BinaKullanimKod?:number;
    BinaMuafEh?:string;
    BinaOran?:number;
    BinaOran1?:number;
    BinaYuzolcum?:number;
    BinaYuzolcumu1?:number;
    BlokNo?:string;
    BolumKod?:number;
    CtvDerece?:number;
    CtvGrup?:number;
    CtvKullanimKod?:number;
    DaimiMuafiyetEh:string;
    DaireNo?:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    Donumu?:number;
    EglTarifeKod?:number;
    EkaKullanimKod?:number;
    EkVergiEh:string;
    EmlakBeyanTuru?:number;
    EskiKisiKod?:number;
    GenelTarifeKod?:number;
    IktisapTarih?:Date;
    IktisapTurKod?:number;
    IlanAracPlaka?:string;
    IlanAracSase?:string;
    IlanBeyanTuru?:string;
    IlanBoy?:number;
    IlanEn?:number;
    IlanMuaf?:number;
    IlanNetToplam?:number;
    IlanSponsorKod?:number;
    IlanTarifeKod?:number;
    IlanToplam?:number;
    IlanYerKod?:number;
    IlanYon?:number;
    ImarPlanNumarasi?:string;
    ImarPlanTarihi?:Date;
    InsaatBitimTarih?:Date;
    InsaatSinifKod?:number;
    InsaatTurKod?:number;
    IsyeriNo?:number;
    KabulTarih:Date;
    KapiNo?:number;
    KapiNo1?:string;
    KatNo?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    KBaslangicTarih?:Date;
    KBitisTarih?:Date;
    KisiKod:number;
    Kod:number;
    KriterKoltuk?:number;
    KriterM2?:number;
    KriterOgrenci?:number;
    KriterPersonel?:number;
    KriterYatak?:number;
    KullanimSekliKod?:number;
    KYuzdesi?:number;
    MahalleCaddeKod:number;
    MalikAciklama?:string;
    MalikKisiKod?:number;
    MBaslangicYil?:number;
    MevkiiAdi?:string;
    ModulKod:number;
    MSure?:number;
    MuafiyetTurKod?:number;
    MukellefBitisKod?:number;
    MukellefBitisTarih?:Date;
    NetArsaAlani?:number;
    NetBinaYuzolcum?:number;
    Pafta?:string;
    Parsel?:number;
    ParselKod?:number;
    SiraNo:number;
    SiteApartmanAd?:string;
    TapuBagimsizNo?:string;
    TapuCiltNo?:number;
    TapuKod?:number;
    TapuSayfaNo?:number;
    VergiBaslangicTarih:Date;
    VerilisNedeni:string;
    YoklamaMemurKod?:number;
    YoklamaNo?:string;
    YoklamaTarihi?:Date;

    constructor(item?:any){
    this.Aciklama=item?.Aciklama;
    this.Ada=item?.Ada;
    this.AraziTurKod=item?.AraziTurKod;
    this.ArsaAlani=item?.ArsaAlani;
    this.ArsaAlani1=item?.ArsaAlani1;
    this.ArsaHisse=item?.ArsaHisse;
    this.ArsaHisse1=item?.ArsaHisse1;
    this.ArsaOran=item?.ArsaOran;
    this.ArsaOran1=item?.ArsaOran1;
    this.AsgariHesapYil=item?.AsgariHesapYil;
    this.BelediyeKod=item?.BelediyeKod||0;
    this.BeyanTipi=item?.BeyanTipi||0;
    this.BildirimSekli=item?.BildirimSekli||'';
    this.BinaAsansorEh=item?.BinaAsansorEh;
    this.BinaHisse=item?.BinaHisse;
    this.BinaHisse1=item?.BinaHisse1;
    this.BinaKaloriferEh=item?.BinaKaloriferEh;
    this.BinaKod=item?.BinaKod;
    this.BinaKullanimKod=item?.BinaKullanimKod;
    this.BinaMuafEh=item?.BinaMuafEh;
    this.BinaOran=item?.BinaOran;
    this.BinaOran1=item?.BinaOran1;
    this.BinaYuzolcum=item?.BinaYuzolcum;
    this.BinaYuzolcumu1=item?.BinaYuzolcumu1;
    this.BlokNo=item?.BlokNo;
    this.BolumKod=item?.BolumKod;
    this.CtvDerece=item?.CtvDerece;
    this.CtvGrup=item?.CtvGrup;
    this.CtvKullanimKod=item?.CtvKullanimKod;
    this.DaimiMuafiyetEh=item?.DaimiMuafiyetEh||'';
    this.DaireNo=item?.DaireNo;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.Donumu=item?.Donumu;
    this.EglTarifeKod=item?.EglTarifeKod;
    this.EkaKullanimKod=item?.EkaKullanimKod;
    this.EkVergiEh=item?.EkVergiEh||'';
    this.EmlakBeyanTuru=item?.EmlakBeyanTuru;
    this.EskiKisiKod=item?.EskiKisiKod;
    this.GenelTarifeKod=item?.GenelTarifeKod;
    this.IktisapTarih=item?.IktisapTarih;
    this.IktisapTurKod=item?.IktisapTurKod;
    this.IlanAracPlaka=item?.IlanAracPlaka;
    this.IlanAracSase=item?.IlanAracSase;
    this.IlanBeyanTuru=item?.IlanBeyanTuru;
    this.IlanBoy=item?.IlanBoy;
    this.IlanEn=item?.IlanEn;
    this.IlanMuaf=item?.IlanMuaf;
    this.IlanNetToplam=item?.IlanNetToplam;
    this.IlanSponsorKod=item?.IlanSponsorKod;
    this.IlanTarifeKod=item?.IlanTarifeKod;
    this.IlanToplam=item?.IlanToplam;
    this.IlanYerKod=item?.IlanYerKod;
    this.IlanYon=item?.IlanYon;
    this.ImarPlanNumarasi=item?.ImarPlanNumarasi;
    this.ImarPlanTarihi=item?.ImarPlanTarihi;
    this.InsaatBitimTarih=item?.InsaatBitimTarih;
    this.InsaatSinifKod=item?.InsaatSinifKod;
    this.InsaatTurKod=item?.InsaatTurKod;
    this.IsyeriNo=item?.IsyeriNo;
    this.KabulTarih=item?.KabulTarih||new Date();
    this.KapiNo=item?.KapiNo;
    this.KapiNo1=item?.KapiNo1;
    this.KatNo=item?.KatNo;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.KBaslangicTarih=item?.KBaslangicTarih;
    this.KBitisTarih=item?.KBitisTarih;
    this.KisiKod=item?.KisiKod||0;
    this.Kod=item?.Kod||0;
    this.KriterKoltuk=item?.KriterKoltuk;
    this.KriterM2=item?.KriterM2;
    this.KriterOgrenci=item?.KriterOgrenci;
    this.KriterPersonel=item?.KriterPersonel;
    this.KriterYatak=item?.KriterYatak;
    this.KullanimSekliKod=item?.KullanimSekliKod;
    this.KYuzdesi=item?.KYuzdesi;
    this.MahalleCaddeKod=item?.MahalleCaddeKod||0;
    this.MalikAciklama=item?.MalikAciklama;
    this.MalikKisiKod=item?.MalikKisiKod;
    this.MBaslangicYil=item?.MBaslangicYil;
    this.MevkiiAdi=item?.MevkiiAdi;
    this.ModulKod=item?.ModulKod||0;
    this.MSure=item?.MSure;
    this.MuafiyetTurKod=item?.MuafiyetTurKod;
    this.MukellefBitisKod=item?.MukellefBitisKod;
    this.MukellefBitisTarih=item?.MukellefBitisTarih;
    this.NetArsaAlani=item?.NetArsaAlani;
    this.NetBinaYuzolcum=item?.NetBinaYuzolcum;
    this.Pafta=item?.Pafta;
    this.Parsel=item?.Parsel;
    this.ParselKod=item?.ParselKod;
    this.SiraNo=item?.SiraNo||0;
    this.SiteApartmanAd=item?.SiteApartmanAd;
    this.TapuBagimsizNo=item?.TapuBagimsizNo;
    this.TapuCiltNo=item?.TapuCiltNo;
    this.TapuKod=item?.TapuKod;
    this.TapuSayfaNo=item?.TapuSayfaNo;
    this.VergiBaslangicTarih=item?.VergiBaslangicTarih||new Date();
    this.VerilisNedeni=item?.VerilisNedeni||'';
    this.YoklamaMemurKod=item?.YoklamaMemurKod;
    this.YoklamaNo=item?.YoklamaNo;
    this.YoklamaTarihi=item?.YoklamaTarihi;
    }
    }

    export class GenAesBolumKullaniciYetki {
    BolumKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KullaniciKod:number;

    constructor(item?:any){
    this.BolumKod=item?.BolumKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KullaniciKod=item?.KullaniciKod||0;
    }
    }

    export class GenArsBasvuru {
    Ad?:string;
    BasvuruSekliKod:number;
    BasvuruTarih:Date;
    BasvuruTuruKod?:number;
    BelediyeKod:number;
    BimerNo?:number;
    BimerTarih?:Date;
    CagriDetayKod?:number;
    CagriKod?:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    EMail?:string;
    FaxAlanKod?:number;
    FaxTelefon?:string;
    GelenEvrakNo?:number;
    GelenEvrakTarih?:Date;
    GizliEh:string;
    GonderIpAdres?:string;
    GonderMacAdres?:string;
    GsmAlanKod?:number;
    GsmTelefon?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    KisiBinaKod?:number;
    KisiBlokNo?:string;
    KisiBolumKod?:number;
    KisiDaireNo?:string;
    KisiKapiNo?:number;
    KisiKapiNo1?:string;
    KisiKod?:number;
    KisiMahalleCaddeKod?:number;
    KisiSiteApartmanAd?:string;
    Kod:number;
    KonuKod:number;
    KoordinatX?:number;
    KoordinatY?:number;
    OnayEh:string;
    OnemDereceKod?:number;
    OrtalamaBitisTarih?:Date;
    PlanKod?:number;
    SabitAlanKod?:number;
    SabitTelefon?:string;
    SonucAciklama?:string;
    SonucFaxEh:string;
    SonucMailEh:string;
    SonucSmsEh:string;
    SonucTarih?:Date;
    SonucTelEh:string;
    SonucTurKod?:number;
    SonucYaziliEh:string;
    Soyad?:string;
    TalepAciklama:string;
    TalepAciklamaSesPath?:string;
    TalepAdresSesPath?:string;
    TalepBinaKod?:number;
    TalepBlokNo?:string;
    TalepBolumKod?:number;
    TalepDaireNo?:string;
    TalepKapiNo?:number;
    TalepKapiNo1?:string;
    TalepKisaTarif?:string;
    TalepKisiSesPath?:string;
    TalepMahalleCaddeKod?:number;
    TalepSiteApartmanAd?:string;
    Tckn?:number;
    Unvani?:string;

    constructor(item?:any){
    this.Ad=item?.Ad;
    this.BasvuruSekliKod=item?.BasvuruSekliKod||0;
    this.BasvuruTarih=item?.BasvuruTarih||new Date();
    this.BasvuruTuruKod=item?.BasvuruTuruKod;
    this.BelediyeKod=item?.BelediyeKod||0;
    this.BimerNo=item?.BimerNo;
    this.BimerTarih=item?.BimerTarih;
    this.CagriDetayKod=item?.CagriDetayKod;
    this.CagriKod=item?.CagriKod;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.EMail=item?.EMail;
    this.FaxAlanKod=item?.FaxAlanKod;
    this.FaxTelefon=item?.FaxTelefon;
    this.GelenEvrakNo=item?.GelenEvrakNo;
    this.GelenEvrakTarih=item?.GelenEvrakTarih;
    this.GizliEh=item?.GizliEh||'';
    this.GonderIpAdres=item?.GonderIpAdres;
    this.GonderMacAdres=item?.GonderMacAdres;
    this.GsmAlanKod=item?.GsmAlanKod;
    this.GsmTelefon=item?.GsmTelefon;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.KisiBinaKod=item?.KisiBinaKod;
    this.KisiBlokNo=item?.KisiBlokNo;
    this.KisiBolumKod=item?.KisiBolumKod;
    this.KisiDaireNo=item?.KisiDaireNo;
    this.KisiKapiNo=item?.KisiKapiNo;
    this.KisiKapiNo1=item?.KisiKapiNo1;
    this.KisiKod=item?.KisiKod;
    this.KisiMahalleCaddeKod=item?.KisiMahalleCaddeKod;
    this.KisiSiteApartmanAd=item?.KisiSiteApartmanAd;
    this.Kod=item?.Kod||0;
    this.KonuKod=item?.KonuKod||0;
    this.KoordinatX=item?.KoordinatX;
    this.KoordinatY=item?.KoordinatY;
    this.OnayEh=item?.OnayEh||'';
    this.OnemDereceKod=item?.OnemDereceKod;
    this.OrtalamaBitisTarih=item?.OrtalamaBitisTarih;
    this.PlanKod=item?.PlanKod;
    this.SabitAlanKod=item?.SabitAlanKod;
    this.SabitTelefon=item?.SabitTelefon;
    this.SonucAciklama=item?.SonucAciklama;
    this.SonucFaxEh=item?.SonucFaxEh||'';
    this.SonucMailEh=item?.SonucMailEh||'';
    this.SonucSmsEh=item?.SonucSmsEh||'';
    this.SonucTarih=item?.SonucTarih;
    this.SonucTelEh=item?.SonucTelEh||'';
    this.SonucTurKod=item?.SonucTurKod;
    this.SonucYaziliEh=item?.SonucYaziliEh||'';
    this.Soyad=item?.Soyad;
    this.TalepAciklama=item?.TalepAciklama||'';
    this.TalepAciklamaSesPath=item?.TalepAciklamaSesPath;
    this.TalepAdresSesPath=item?.TalepAdresSesPath;
    this.TalepBinaKod=item?.TalepBinaKod;
    this.TalepBlokNo=item?.TalepBlokNo;
    this.TalepBolumKod=item?.TalepBolumKod;
    this.TalepDaireNo=item?.TalepDaireNo;
    this.TalepKapiNo=item?.TalepKapiNo;
    this.TalepKapiNo1=item?.TalepKapiNo1;
    this.TalepKisaTarif=item?.TalepKisaTarif;
    this.TalepKisiSesPath=item?.TalepKisiSesPath;
    this.TalepMahalleCaddeKod=item?.TalepMahalleCaddeKod;
    this.TalepSiteApartmanAd=item?.TalepSiteApartmanAd;
    this.Tckn=item?.Tckn;
    this.Unvani=item?.Unvani;
    }
    }

    export class GenArsBasvuruBirim {
    BasvuruKod:number;
    BelediyeKod:number;
    BirimKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    IsSiraNo:number;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KullaniciKod:number;
    SonucAciklama?:string;
    SonucTarih?:Date;
    SonucTurKod?:number;

    constructor(item?:any){
    this.BasvuruKod=item?.BasvuruKod||0;
    this.BelediyeKod=item?.BelediyeKod||0;
    this.BirimKod=item?.BirimKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.IsSiraNo=item?.IsSiraNo||0;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KullaniciKod=item?.KullaniciKod||0;
    this.SonucAciklama=item?.SonucAciklama;
    this.SonucTarih=item?.SonucTarih;
    this.SonucTurKod=item?.SonucTurKod;
    }
    }

    export class GenArsBasvuruBirimDetay {
    BasvuruBirimKod:number;
    BasvuruKod:number;
    BelediyeKod:number;
    BirimKod?:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    IsSiraNo:number;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KullaniciKod:number;
    SonucAciklama?:string;
    SonucTarih?:Date;
    SonucTurKod?:number;

    constructor(item?:any){
    this.BasvuruBirimKod=item?.BasvuruBirimKod||0;
    this.BasvuruKod=item?.BasvuruKod||0;
    this.BelediyeKod=item?.BelediyeKod||0;
    this.BirimKod=item?.BirimKod;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.IsSiraNo=item?.IsSiraNo||0;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KullaniciKod=item?.KullaniciKod||0;
    this.SonucAciklama=item?.SonucAciklama;
    this.SonucTarih=item?.SonucTarih;
    this.SonucTurKod=item?.SonucTurKod;
    }
    }

    export class GenArsBasvuruGorusme {
    Aciklama?:string;
    BasvuruKod:number;
    BelediyeKod:number;
    BirimAdi?:string;
    BirimKod?:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    GorusmeTarih:Date;
    GorusulenAdi?:string;
    GorusulenGorevi?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KullaniciKod:number;

    constructor(item?:any){
    this.Aciklama=item?.Aciklama;
    this.BasvuruKod=item?.BasvuruKod||0;
    this.BelediyeKod=item?.BelediyeKod||0;
    this.BirimAdi=item?.BirimAdi;
    this.BirimKod=item?.BirimKod;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.GorusmeTarih=item?.GorusmeTarih||new Date();
    this.GorusulenAdi=item?.GorusulenAdi;
    this.GorusulenGorevi=item?.GorusulenGorevi;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KullaniciKod=item?.KullaniciKod||0;
    }
    }

    export class GenArsBirimKullanici {
    AktifEh:string;
    BelediyeKod:number;
    BirimKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    GizliBasvuruGorsunEh:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KullaniciKod:number;
    MailTuru:string;
    SmsTuru:string;

    constructor(item?:any){
    this.AktifEh=item?.AktifEh||'';
    this.BelediyeKod=item?.BelediyeKod||0;
    this.BirimKod=item?.BirimKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.GizliBasvuruGorsunEh=item?.GizliBasvuruGorsunEh||'';
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KullaniciKod=item?.KullaniciKod||0;
    this.MailTuru=item?.MailTuru||'';
    this.SmsTuru=item?.SmsTuru||'';
    }
    }

    export class GenArsKonuBirim {
    BelediyeKod:number;
    BirimKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    IsSiraNo:number;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KonuKod:number;
    KullaniciKod:number;

    constructor(item?:any){
    this.BelediyeKod=item?.BelediyeKod||0;
    this.BirimKod=item?.BirimKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.IsSiraNo=item?.IsSiraNo||0;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KonuKod=item?.KonuKod||0;
    this.KullaniciKod=item?.KullaniciKod||0;
    }
    }

    export class GenBysBirimKullaniciYetki {
    BirimEvrakSorgulaEh?:string;
    BirimKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    GuvenlikDurumu:number;
    KalemEh:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KullaniciKod:number;
    MailEh?:string;
    ServisKod?:number;
    SmsEh?:string;

    constructor(item?:any){
    this.BirimEvrakSorgulaEh=item?.BirimEvrakSorgulaEh;
    this.BirimKod=item?.BirimKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.GuvenlikDurumu=item?.GuvenlikDurumu||0;
    this.KalemEh=item?.KalemEh||'';
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KullaniciKod=item?.KullaniciKod||0;
    this.MailEh=item?.MailEh;
    this.ServisKod=item?.ServisKod;
    this.SmsEh=item?.SmsEh;
    }
    }

    export class GenCmyBasvuruBirim {
    BasvuruKod:number;
    BelediyeKod:number;
    BirimKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    FormBasildiEh?:string;
    IsSiraNo:number;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KonuDegisNedeni?:string;
    KullaniciKod:number;
    PlanKod?:number;
    SonucAciklama?:string;
    SonucTarih?:Date;
    SonucTurKod?:number;
    Status?:number;

    constructor(item?:any){
    this.BasvuruKod=item?.BasvuruKod||0;
    this.BelediyeKod=item?.BelediyeKod||0;
    this.BirimKod=item?.BirimKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.FormBasildiEh=item?.FormBasildiEh;
    this.IsSiraNo=item?.IsSiraNo||0;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KonuDegisNedeni=item?.KonuDegisNedeni;
    this.KullaniciKod=item?.KullaniciKod||0;
    this.PlanKod=item?.PlanKod;
    this.SonucAciklama=item?.SonucAciklama;
    this.SonucTarih=item?.SonucTarih;
    this.SonucTurKod=item?.SonucTurKod;
    this.Status=item?.Status;
    }
    }

    export class GenCmyBasvuruBirimDetay {
    BasvuruBirimKod:number;
    BasvuruKod:number;
    BelediyeKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    IsSiraNo:number;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KullaniciKod:number;
    SonucAciklama?:string;
    SonucTarih?:Date;
    SonucTurKod?:number;

    constructor(item?:any){
    this.BasvuruBirimKod=item?.BasvuruBirimKod||0;
    this.BasvuruKod=item?.BasvuruKod||0;
    this.BelediyeKod=item?.BelediyeKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.IsSiraNo=item?.IsSiraNo||0;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KullaniciKod=item?.KullaniciKod||0;
    this.SonucAciklama=item?.SonucAciklama;
    this.SonucTarih=item?.SonucTarih;
    this.SonucTurKod=item?.SonucTurKod;
    }
    }

    export class GenCmyBasvuruGorusme {
    Aciklama?:string;
    BasvuruKod:number;
    BelediyeKod:number;
    BirimAdi?:string;
    BirimKod?:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    GorusmeTarih:Date;
    GorusulenAdi?:string;
    GorusulenGorevi?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KullaniciKod:number;

    constructor(item?:any){
    this.Aciklama=item?.Aciklama;
    this.BasvuruKod=item?.BasvuruKod||0;
    this.BelediyeKod=item?.BelediyeKod||0;
    this.BirimAdi=item?.BirimAdi;
    this.BirimKod=item?.BirimKod;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.GorusmeTarih=item?.GorusmeTarih||new Date();
    this.GorusulenAdi=item?.GorusulenAdi;
    this.GorusulenGorevi=item?.GorusulenGorevi;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KullaniciKod=item?.KullaniciKod||0;
    }
    }

    export class GenCmyBirimKullanici {
    AktifEh:string;
    BelediyeKod:number;
    BirimKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    GizliBasvuruGorsunEh:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KullaniciKod:number;
    MailTuru:string;
    SmsTuru:string;

    constructor(item?:any){
    this.AktifEh=item?.AktifEh||'';
    this.BelediyeKod=item?.BelediyeKod||0;
    this.BirimKod=item?.BirimKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.GizliBasvuruGorsunEh=item?.GizliBasvuruGorsunEh||'';
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KullaniciKod=item?.KullaniciKod||0;
    this.MailTuru=item?.MailTuru||'';
    this.SmsTuru=item?.SmsTuru||'';
    }
    }

    export class GenCmyCagriAgent {
    Ad:string;
    AgentId?:string;
    AgentKullaniciKod?:number;
    BelediyeKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;

    constructor(item?:any){
    this.Ad=item?.Ad||'';
    this.AgentId=item?.AgentId;
    this.AgentKullaniciKod=item?.AgentKullaniciKod;
    this.BelediyeKod=item?.BelediyeKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    }
    }

    export class GenCmyKonuBirim {
    BelediyeKod:number;
    BirimKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    IsSiraNo:number;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KonuKod:number;
    KullaniciKod:number;

    constructor(item?:any){
    this.BelediyeKod=item?.BelediyeKod||0;
    this.BirimKod=item?.BirimKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.IsSiraNo=item?.IsSiraNo||0;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KonuKod=item?.KonuKod||0;
    this.KullaniciKod=item?.KullaniciKod||0;
    }
    }

    export class GenCmyKonuKullanici {
    BelediyeKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KonuKod:number;
    KullaniciKod:number;
    MailGonderEh:string;
    SmsGonderEh:string;

    constructor(item?:any){
    this.BelediyeKod=item?.BelediyeKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KonuKod=item?.KonuKod||0;
    this.KullaniciKod=item?.KullaniciKod||0;
    this.MailGonderEh=item?.MailGonderEh||'';
    this.SmsGonderEh=item?.SmsGonderEh||'';
    }
    }

    export class GenCmyMuhtar {
    Ad:string;
    BelediyeKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    GsmAlanKod?:number;
    GsmTelefon?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KullaniciKod:number;
    MahalleKod:number;
    SabitAlanKod?:number;
    SabitTelefon?:string;
    Soyad:string;
    Tckn:number;

    constructor(item?:any){
    this.Ad=item?.Ad||'';
    this.BelediyeKod=item?.BelediyeKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.GsmAlanKod=item?.GsmAlanKod;
    this.GsmTelefon=item?.GsmTelefon;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KullaniciKod=item?.KullaniciKod||0;
    this.MahalleKod=item?.MahalleKod||0;
    this.SabitAlanKod=item?.SabitAlanKod;
    this.SabitTelefon=item?.SabitTelefon;
    this.Soyad=item?.Soyad||'';
    this.Tckn=item?.Tckn||0;
    }
    }

    export class GenGasBirimDosyaYetki {
    BelgeTuruKod:number;
    BirimDosyaKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KullaniciKod:number;
    YetkiEh:string;

    constructor(item?:any){
    this.BelgeTuruKod=item?.BelgeTuruKod||0;
    this.BirimDosyaKod=item?.BirimDosyaKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KullaniciKod=item?.KullaniciKod||0;
    this.YetkiEh=item?.YetkiEh||'';
    }
    }

    export class GenGasBirimKullaniciYetki {
    AktifEh:string;
    BirimKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    DegistirEh:string;
    KayitEh:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KullaniciKod:number;
    SilEh:string;
    SorumluEh:string;

    constructor(item?:any){
    this.AktifEh=item?.AktifEh||'';
    this.BirimKod=item?.BirimKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.DegistirEh=item?.DegistirEh||'';
    this.KayitEh=item?.KayitEh||'';
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KullaniciKod=item?.KullaniciKod||0;
    this.SilEh=item?.SilEh||'';
    this.SorumluEh=item?.SorumluEh||'';
    }
    }

    export class GenGysGelirYetki {
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    IconUrl?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KullaniciKod:number;
    ModulKod:number;

    constructor(item?:any){
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.IconUrl=item?.IconUrl;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KullaniciKod=item?.KullaniciKod||0;
    this.ModulKod=item?.ModulKod||0;
    }
    }

    export class GenIkaBirimKullanici {
    BelediyeKod:number;
    BirimKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KullaniciKod:number;

    constructor(item?:any){
    this.BelediyeKod=item?.BelediyeKod||0;
    this.BirimKod=item?.BirimKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KullaniciKod=item?.KullaniciKod||0;
    }
    }

    export class GenIkaPersonel {
    Aciklama?:string;
    Ad?:string;
    AnneAd?:string;
    BabaAd?:string;
    BelediyeKod:number;
    CikisTarih?:Date;
    CikisTurKod?:number;
    Cinsiyet?:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    DiniKod?:number;
    DogumTarih?:Date;
    DogumYeriAciklama?:string;
    DogumYeriKod?:number;
    EhliyetNo?:number;
    EhliyetTarih?:Date;
    EhliyetTuruKod?:number;
    EMail?:string;
    EmekliGorevTarih?:Date;
    EmekliSandikNo?:string;
    EmekliYeniSandikNo?:string;
    GorevBirimKod?:number;
    GsmAlanKod?:number;
    GsmTelefon?:string;
    GssNo?:string;
    IbanNo?:string;
    IlkGirisTarih:Date;
    IzinBaslangicTarih:Date;
    KadroBirimKod?:number;
    KanGrubu?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    KefaletCuzdanNo?:string;
    KisiKod?:number;
    Kod:number;
    KurumGirisTarih?:Date;
    KurumSicilNo?:string;
    MailBilgiEh?:string;
    MalulKod?:number;
    MedeniDurumKod?:number;
    NAileSiraNo?:string;
    NCiltNo?:string;
    NCuzdanKayitNo?:number;
    NCuzdanSeriNo?:string;
    NCuzdanSiraNo?:number;
    NCuzdanVerilisKod?:number;
    NIdaresiKod?:number;
    NKayitliMahalleKoy?:string;
    NKayitliYerKod?:number;
    NSiraNo?:string;
    NVerildigiTarih?:Date;
    OncekiSoyad?:string;
    PersonelKod:number;
    PersonelTurKod:number;
    SebepKod?:number;
    SmsBilgiEh?:string;
    Soyad?:string;
    SskNo?:string;
    TasarrufNo?:string;
    TaseronFirmaKod?:number;
    Tckn?:number;
    UyrukKod?:number;
    VergiDairesi?:string;
    VergiNo?:string;

    constructor(item?:any){
    this.Aciklama=item?.Aciklama;
    this.Ad=item?.Ad;
    this.AnneAd=item?.AnneAd;
    this.BabaAd=item?.BabaAd;
    this.BelediyeKod=item?.BelediyeKod||0;
    this.CikisTarih=item?.CikisTarih;
    this.CikisTurKod=item?.CikisTurKod;
    this.Cinsiyet=item?.Cinsiyet;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.DiniKod=item?.DiniKod;
    this.DogumTarih=item?.DogumTarih;
    this.DogumYeriAciklama=item?.DogumYeriAciklama;
    this.DogumYeriKod=item?.DogumYeriKod;
    this.EhliyetNo=item?.EhliyetNo;
    this.EhliyetTarih=item?.EhliyetTarih;
    this.EhliyetTuruKod=item?.EhliyetTuruKod;
    this.EMail=item?.EMail;
    this.EmekliGorevTarih=item?.EmekliGorevTarih;
    this.EmekliSandikNo=item?.EmekliSandikNo;
    this.EmekliYeniSandikNo=item?.EmekliYeniSandikNo;
    this.GorevBirimKod=item?.GorevBirimKod;
    this.GsmAlanKod=item?.GsmAlanKod;
    this.GsmTelefon=item?.GsmTelefon;
    this.GssNo=item?.GssNo;
    this.IbanNo=item?.IbanNo;
    this.IlkGirisTarih=item?.IlkGirisTarih||new Date();
    this.IzinBaslangicTarih=item?.IzinBaslangicTarih||new Date();
    this.KadroBirimKod=item?.KadroBirimKod;
    this.KanGrubu=item?.KanGrubu;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.KefaletCuzdanNo=item?.KefaletCuzdanNo;
    this.KisiKod=item?.KisiKod;
    this.Kod=item?.Kod||0;
    this.KurumGirisTarih=item?.KurumGirisTarih;
    this.KurumSicilNo=item?.KurumSicilNo;
    this.MailBilgiEh=item?.MailBilgiEh;
    this.MalulKod=item?.MalulKod;
    this.MedeniDurumKod=item?.MedeniDurumKod;
    this.NAileSiraNo=item?.NAileSiraNo;
    this.NCiltNo=item?.NCiltNo;
    this.NCuzdanKayitNo=item?.NCuzdanKayitNo;
    this.NCuzdanSeriNo=item?.NCuzdanSeriNo;
    this.NCuzdanSiraNo=item?.NCuzdanSiraNo;
    this.NCuzdanVerilisKod=item?.NCuzdanVerilisKod;
    this.NIdaresiKod=item?.NIdaresiKod;
    this.NKayitliMahalleKoy=item?.NKayitliMahalleKoy;
    this.NKayitliYerKod=item?.NKayitliYerKod;
    this.NSiraNo=item?.NSiraNo;
    this.NVerildigiTarih=item?.NVerildigiTarih;
    this.OncekiSoyad=item?.OncekiSoyad;
    this.PersonelKod=item?.PersonelKod||0;
    this.PersonelTurKod=item?.PersonelTurKod||0;
    this.SebepKod=item?.SebepKod;
    this.SmsBilgiEh=item?.SmsBilgiEh;
    this.Soyad=item?.Soyad;
    this.SskNo=item?.SskNo;
    this.TasarrufNo=item?.TasarrufNo;
    this.TaseronFirmaKod=item?.TaseronFirmaKod;
    this.Tckn=item?.Tckn;
    this.UyrukKod=item?.UyrukKod;
    this.VergiDairesi=item?.VergiDairesi;
    this.VergiNo=item?.VergiNo;
    }
    }

    export class GenIkaPersonelTurYetki {
    BelediyeKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KullaniciKod:number;
    PersonelTurKod:number;

    constructor(item?:any){
    this.BelediyeKod=item?.BelediyeKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KullaniciKod=item?.KullaniciKod||0;
    this.PersonelTurKod=item?.PersonelTurKod||0;
    }
    }

    export class GenSysAmbarYetki {
    AktifEh:string;
    AmbarKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KullaniciKod:number;

    constructor(item?:any){
    this.AktifEh=item?.AktifEh||'';
    this.AmbarKod=item?.AmbarKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KullaniciKod=item?.KullaniciKod||0;
    }
    }

    export class GenSysEkipDetay {
    Ad?:string;
    BelediyeKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    EkipKod:number;
    Gorevi?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KullaniciKod:number;
    PersonelKod?:number;
    Soyad?:string;

    constructor(item?:any){
    this.Ad=item?.Ad;
    this.BelediyeKod=item?.BelediyeKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.EkipKod=item?.EkipKod||0;
    this.Gorevi=item?.Gorevi;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KullaniciKod=item?.KullaniciKod||0;
    this.PersonelKod=item?.PersonelKod;
    this.Soyad=item?.Soyad;
    }
    }

    export class GenSysYardimTur {
    Ad:string;
    AmbarKod?:number;
    BelediyeKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    DepoKontrolEh?:string;
    IlkPuan?:number;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    MalzemeZorunluEh?:string;
    OrgKullaniciKod?:number;
    ProgramOtomatikEh?:string;
    PuanEh:string;
    SonPuan?:number;
    YardimGrupKod?:number;

    constructor(item?:any){
    this.Ad=item?.Ad||'';
    this.AmbarKod=item?.AmbarKod;
    this.BelediyeKod=item?.BelediyeKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.DepoKontrolEh=item?.DepoKontrolEh;
    this.IlkPuan=item?.IlkPuan;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.MalzemeZorunluEh=item?.MalzemeZorunluEh;
    this.OrgKullaniciKod=item?.OrgKullaniciKod;
    this.ProgramOtomatikEh=item?.ProgramOtomatikEh;
    this.PuanEh=item?.PuanEh||'';
    this.SonPuan=item?.SonPuan;
    this.YardimGrupKod=item?.YardimGrupKod;
    }
    }

    export class GenSysYardimTurYetki {
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KullaniciKod:number;
    YardimTurKod:number;

    constructor(item?:any){
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KullaniciKod=item?.KullaniciKod||0;
    this.YardimTurKod=item?.YardimTurKod||0;
    }
    }

    export class GenTemDefterKullanici {
    DefterKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KullaniciKod:number;

    constructor(item?:any){
    this.DefterKod=item?.DefterKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KullaniciKod=item?.KullaniciKod||0;
    }
    }

    export class GenTmsAmbarYetki {
    AktifEh:string;
    AmbarKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KullaniciKod:number;

    constructor(item?:any){
    this.AktifEh=item?.AktifEh||'';
    this.AmbarKod=item?.AmbarKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KullaniciKod=item?.KullaniciKod||0;
    }
    }

    export class GenTtsBasvuru {
    BasvuruTarih:Date;
    BasvuruTurKod:number;
    BugEh:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    FormKod?:number;
    GonderIpAdres?:string;
    GonderMacAdres?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KurumKod:number;
    KurumKullaniciKod?:number;
    OnayTarih?:Date;
    OncelikDurum:string;
    PlanlananBitisTarih?:Date;
    RedSayisi?:number;
    SonucAciklama?:string;
    SonucKullaniciKod?:number;
    SonucTarih?:Date;
    SonucTurKod?:number;
    Status:number;
    TalepAciklama:string;
    Turu:number;
    UygulamaKod?:number;

    constructor(item?:any){
    this.BasvuruTarih=item?.BasvuruTarih||new Date();
    this.BasvuruTurKod=item?.BasvuruTurKod||0;
    this.BugEh=item?.BugEh||'';
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.FormKod=item?.FormKod;
    this.GonderIpAdres=item?.GonderIpAdres;
    this.GonderMacAdres=item?.GonderMacAdres;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KurumKod=item?.KurumKod||0;
    this.KurumKullaniciKod=item?.KurumKullaniciKod;
    this.OnayTarih=item?.OnayTarih;
    this.OncelikDurum=item?.OncelikDurum||'';
    this.PlanlananBitisTarih=item?.PlanlananBitisTarih;
    this.RedSayisi=item?.RedSayisi;
    this.SonucAciklama=item?.SonucAciklama;
    this.SonucKullaniciKod=item?.SonucKullaniciKod;
    this.SonucTarih=item?.SonucTarih;
    this.SonucTurKod=item?.SonucTurKod;
    this.Status=item?.Status||0;
    this.TalepAciklama=item?.TalepAciklama||'';
    this.Turu=item?.Turu||0;
    this.UygulamaKod=item?.UygulamaKod;
    }
    }

    export class GenTtsBasvuruDetay {
    Aciklama?:string;
    BasvuruKod:number;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    FaaliyetTurKod?:number;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KullaniciKod:number;
    KurumKod:number;
    SonucAciklama?:string;
    SonucTarih?:Date;
    SonucTurKod?:number;

    constructor(item?:any){
    this.Aciklama=item?.Aciklama;
    this.BasvuruKod=item?.BasvuruKod||0;
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.FaaliyetTurKod=item?.FaaliyetTurKod;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KullaniciKod=item?.KullaniciKod||0;
    this.KurumKod=item?.KurumKod||0;
    this.SonucAciklama=item?.SonucAciklama;
    this.SonucTarih=item?.SonucTarih;
    this.SonucTurKod=item?.SonucTurKod;
    }
    }

    export class GenTtsKullanici {
    Adi:string;
    AktifEh:string;
    DegisKullaniciKod?:number;
    DegisTarih?:Date;
    EPosta?:string;
    GsmTelefon?:string;
    KayitKullaniciKod:number;
    KayitTarih:Date;
    Kod:number;
    KullaniciKod:string;
    KurumKod:number;
    SabitTelefon?:string;
    Sifre:string;
    SistemKullaniciKod?:number;
    Soyad:string;
    Unvan?:string;
    YoneticiEh:string;

    constructor(item?:any){
    this.Adi=item?.Adi||'';
    this.AktifEh=item?.AktifEh||'';
    this.DegisKullaniciKod=item?.DegisKullaniciKod;
    this.DegisTarih=item?.DegisTarih;
    this.EPosta=item?.EPosta;
    this.GsmTelefon=item?.GsmTelefon;
    this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
    this.KayitTarih=item?.KayitTarih||new Date();
    this.Kod=item?.Kod||0;
    this.KullaniciKod=item?.KullaniciKod||'';
    this.KurumKod=item?.KurumKod||0;
    this.SabitTelefon=item?.SabitTelefon;
    this.Sifre=item?.Sifre||'';
    this.SistemKullaniciKod=item?.SistemKullaniciKod;
    this.Soyad=item?.Soyad||'';
    this.Unvan=item?.Unvan;
    this.YoneticiEh=item?.YoneticiEh||'';
    }
    }



export class GenSmsGrupTur {
  Aciklama?:string;
  AktifEh?:string;
  AnaKod?:number;
  DegisKullaniciKod?:number;
  DegisTarih?:Date;
  KayitKullaniciKod?:number;
  KayitTarih?:Date;
  KisaKod?:string;
  Kod?:number;
  Sira?:number;
  TamKod?:string;

  constructor(item?:any){
  this.Aciklama=item?.Aciklama;
  this.AktifEh=item?.AktifEh;
  this.AnaKod=item?.AnaKod;
  this.DegisKullaniciKod=item?.DegisKullaniciKod;
  this.DegisTarih=item?.DegisTarih;
  this.KayitKullaniciKod=item?.KayitKullaniciKod;
  this.KayitTarih=item?.KayitTarih;
  this.KisaKod=item?.KisaKod;
  this.Kod=item?.Kod;
  this.Sira=item?.Sira;
  this.TamKod=item?.TamKod;
  }
  }
